//------------------------------------------------------------------------------------

import '../internal.scss';

import {
    CheckCircle,
    Clear,
    Edit,
    ExpandLess,
    ExpandMore,
    Refresh,
} from '../../../components/Icons/Icons';
import { useEffect, useRef, useState } from 'react';

import Buffer from '../../../components/Buffer/Buffer';
import CheckUncheck from '../../../components/CheckUncheck/CheckUncheck';
import Fallback from '../../../components/Fallback/Fallback';
import Footer from '../../../components/Footer/Footer';
import Header from '../../../components/Header/Header';
import Loading from '../../../components/Loading/Loading';
import Navigation from '../../../components/Navigation/Navigation';
import Pagination from '../../../components/Pagination/Pagination';
import auth from '../../../scripts/auth';
import axios from 'axios';
import baseUrl, { userBaseUrl } from '../../../scripts/baseUrl';
import calculateDateStatus from '../../../scripts/calculateDateStatus';
import filterOwnersByDepartment from '../../../scripts/filterOwnersByDepartment';
import filterOwnersByStation from '../../../scripts/filterOwnersByStation';
import hightlight from '../../../scripts/hightlighter';
import sortTable from '../../../scripts/sort';
import unauthorizedRedirection from '../../../scripts/unauthorizedRedirection';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { socket } from '../../../App';

//------------------------------------------------------------------------------------

let searchTextField = '';

const Owners = () => {
    unauthorizedRedirection();
    document.title = `Contractors â€¢ Bhusawal Division Catering Vendor Id`;

    let accessToken =
        (localStorage.getItem('admin') == null ||
            localStorage.getItem('admin') == '') &&
        (localStorage.getItem('employee') != null ||
            localStorage.getItem('employee') != '')
            ? JSON.parse(localStorage.getItem('employee')).accessToken
            : JSON.parse(localStorage.getItem('admin')).accessToken;

    const currentScreen = useLocation().pathname;

    const navigate = useNavigate();
    const [owners, setOwners] = useState([]);
    const [notFound, setNotFound] = useState(true);
    const [buffer, setBuffer] = useState(true);
    const [loader, setLoader] = useState(false);

    const [isRefreshing, setIsRefreshing] = useState(false);
    const [fetchComplete, setFetchComplete] = useState(false);

    const [stations, setStations] = useState([]);

    const [totalItems, setTotalItems] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(2);
    const [currentPage,setCurrentPage] = useState(1)

    const [searchText, setSearchText] = useState({
        search: '',
    });

    const [ownerTotalItems, setOwnerTotalItems] = useState(0);
    const [ownerItemsPerPage, setOwnerItemsPerPage] = useState(20);
    const [ownerActivePage, setOwnerActivePage] = useState(1);

    const loggedInAdmin =
        localStorage.getItem('admin') != null && localStorage.getItem('admin') != ''
            ? JSON.parse(localStorage.getItem('admin'))
            : null;
    const isSuperAdmin = loggedInAdmin && loggedInAdmin.superAdmin == 1;

    const [departmentView, setDepartmentView] = useState('All');

    const applyDepartmentView = (ownersArray) => {
        if (!isSuperAdmin) return ownersArray;
        if (departmentView === 'Catering') {
            return ownersArray.filter((owner) => owner.department === 'Catering');
        }
        if (departmentView === 'Other') {
            return ownersArray.filter((owner) => owner.department === 'Other');
        }
        return ownersArray;
    };

    const selectDepartmentView = (view) => {
        setDepartmentView(view);
        setOwnerActivePage(1);
    };

    //---------------------------------------------------------
    const [OWNERID,setOwnerId] = useState('');

    const [dialog, setDialog] = useState(false);
    let dialogIndex = 0;

    console.log("totalitem - ",totalItems);
    console.log("itemperpaeg - ",itemsPerPage);
    console.log("ownertotalitem - ",ownerTotalItems);
    console.log("owneritemperpage - ",ownerItemsPerPage);


    const [isModalOpen, setIsModalOpen] = useState(false);
    const [supportingStaffValues, setSupportingStaffValues] = useState({
        manager: 0,
        assistantManager: 0,
        supervisor: 0,
        assistantSupervisor: 0,
        cook: 0,
        assistantCook: 0,
        helper: 0,
        cleaner: 0,
    });

    // Open modal
    const openModal = () => {
        setIsModalOpen(true);
    };

    // Close modal
    const closeModal = () => {
        setIsModalOpen(false);
    };

      // Handle input change
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSupportingStaffValues({
            ...supportingStaffValues,
            [name]: parseInt(value) || 0,
        });
    };

    // Calculate total supporting staff
    const calculateTotalStaff = () => {
        return Object.values(supportingStaffValues).reduce((a, b) => a + b, 0);
    };



    const fetchSupportingStaffData = async (ownerId) => {
        try {
            const response = await axios.get(`${baseUrl}/supportingStaff/${ownerId}`);
    
            // Axios does not have an 'ok' property. Instead, check for the status code directly.
            if (response.status !== 200) {
                throw new Error(`Error fetching data: ${response.statusText}`);
            }
    
            // Use response.data to access the data returned from the server
            console.log("Response data fetch staff:", response.data);
            setSupportingStaffValues(response.data); // Set the state with the fetched data
            openModal(); // Open the modal to edit the data
        } catch (error) {
            console.error('Error:', error);
            console.log("Error message:", error.message);
        }
    };


    const changeSupportingStaff = async (ownerId, supportingStaff) => {
        
    //    await fetchSupportingStaffData(ownerId);
        //  openModal()
        let value = window.prompt(
            'Update supporting staff count',
            supportingStaff
        );

        const data = {
            id: ownerId,
            supportingStaff: value,
            adminId: JSON.parse(localStorage.getItem('admin')).id,
        };

        if (value) {
            try {
                // setNotFound(true);
                // setBuffer(true);
                setLoader(true);
                const res = await axios.put(
                    `${baseUrl}/owners/updateSupportingStaffCount`,
                    data,
                    {
                        headers: {
                            'access-token': accessToken,
                        },
                    }
                );
                setLoader(false);

                if (!auth(res.data.message)) return;

                if (res.data) {
                    // getOwners();

                    for (let i = 0; i < owners.length; i++) {
                        for (let n = 0; n < owners[i].length; n++) {
                            if (owners[i][n].id === ownerId) {
                                setOwners((prev) => [
                                    ...prev,
                                    (prev[i][n].supportingStaff = value),
                                ]);
                            }
                        }
                    }

                    socket.emit('updateOwner', {
                        message: 'updateOwner',
                    });
                } else {
                    // setNotFound(true);
                }
                // setBuffer(false);
            } catch (err) {
                console.log(err);
            }
        }
    };

    // let value;
    // const handleSave = async () => {
    //     try {
    //         // Prepare the data to be sent to the backend
    //         const updatedData = {
    //             manager: supportingStaffValues.manager,
    //             assistantManager: supportingStaffValues.assistantManager,
    //             supervisor: supportingStaffValues.supervisor,
    //             assistantSupervisor: supportingStaffValues.assistantSupervisor,
    //             cook: supportingStaffValues.cook,
    //             assistantCook: supportingStaffValues.assistantCook,
    //             helper: supportingStaffValues.helper,
    //             cleaner: supportingStaffValues.cleaner,
    //         };
    
    //         console.log("updated data ",updatedData);
    //         // Replace 'ownerId' with the actual ID you are working with
    //          // Make sure to get this ID from your state or props
    
    //         // Send the PUT request to the backend
    //         const response = await axios.put(`${baseUrl}/supportingStaff/${OWNERID}`, updatedData);
    
    //         if (response.status === 200) {
    //             // Successfully saved
    //             console.log('Data saved successfully:', response.data);

    //          value = manager+assistantManager+assistantCook+cook+helper+supervisor+assistantSupervisor+cleaner
    //              const data = {
    //         id: OWNERID,
    //         supportingStaff: value,
    //         adminId: JSON.parse(localStorage.getItem('admin')).id,
    //     };

    //     console.log("valueeee ",value);

    //     if (value) {
    //         try {
    //             // setNotFound(true);
    //             // setBuffer(true);
    //             setLoader(true);
    //             const res = await axios.put(
    //                 `${baseUrl}/owners/updateSupportingStaffCount`,
    //                 data,
    //                 {
    //                     headers: {
    //                         'access-token': accessToken,
    //                     },
    //                 }
    //             );
    //             setLoader(false);

    //             if (!auth(res.data.message)) return;

    //             if (res.data) {
    //                 // getOwners();

    //                 for (let i = 0; i < owners.length; i++) {
    //                     for (let n = 0; n < owners[i].length; n++) {
    //                         if (owners[i][n].id === OWNERID) {
    //                             setOwners((prev) => [
    //                                 ...prev,
    //                                 (prev[i][n].supportingStaff = value),
    //                             ]);
    //                         }
    //                     }
    //                 }

    //                 socket.emit('updateOwner', {
    //                     message: 'updateOwner',
    //                 });
    //             } else {
    //                 // setNotFound(true);
    //             }
    //             // setBuffer(false);
    //         } catch (err) {
    //             console.log(err);
    //         }
    //     }


    //             closeModal(); // Optionally close the modal
    //         } else {
    //             console.error('Error saving data:', response.statusText);
    //         }
    //     } catch (error) {
    //         console.error('Error:', error);
    //     }
    // };

    const handleSave = async () => {
        try {
            // Prepare the supporting staff data to be sent to the backend
            const updatedData = {
                manager: supportingStaffValues.manager,
                assistantManager: supportingStaffValues.assistantManager,
                supervisor: supportingStaffValues.supervisor,
                assistantSupervisor: supportingStaffValues.assistantSupervisor,
                cook: supportingStaffValues.cook,
                assistantCook: supportingStaffValues.assistantCook,
                helper: supportingStaffValues.helper,
                cleaner: supportingStaffValues.cleaner,
            };
    
            console.log("Updated data:", updatedData);
    
            // Send the PUT request to update individual staff values
            const response = await axios.put(`${baseUrl}/supportingStaff/${OWNERID}`, updatedData);
    
            if (response.status === 200) {
                console.log('Data saved successfully:', response.data);
    
                // Calculate the total supporting staff count
                const value = 
                    updatedData.manager +
                    updatedData.assistantManager +
                    updatedData.supervisor +
                    updatedData.assistantSupervisor +
                    updatedData.cook +
                    updatedData.assistantCook +
                    updatedData.helper +
                    updatedData.cleaner;
    
                const data = {
                    id: OWNERID,
                    supportingStaff: value,
                    adminId: JSON.parse(localStorage.getItem('admin')).id,
                };
    
                console.log("Supporting staff total:", value);
    
                try {
                    setLoader(true);
                    const res = await axios.put(
                        `${baseUrl}/owners/updateSupportingStaffCount`,
                        data,
                        {
                            headers: {
                                'access-token': accessToken,
                            },
                        }
                    );
                    setLoader(false);
    
                    if (!auth(res.data.message)) return;
    
                    // if (res.data) {
                    //     // Update the owners state
                    //     for (let i = 0; i < owners.length; i++) {
                    //          for (let n = 0; n < owners[i].length; n++) {
                    //             if (owners[i][n].id === OWNERID) {
                    //            setOwners((prev) => [
                    //        ...prev,
                    //            (prev[i][n].supportingStaff = value),
                    //         ]);
                    //        }
                    //    }
                    //    }
                        
                  
                    // }
                    getOwners()
                    
                    socket.emit('updateOwner', {
                        message: 'updateOwner',
                        });
                  window.location.reload();
                    closeModal(); // Close modal only after successful update
                } catch (error) {
                    console.error("Error updating supporting staff count:", error);
                }
            } else {
                console.error('Error saving data:', response.statusText);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };
    
    
console.log("ownersss - ",owners);

    const openDialog = (index) => {
        dialogIndex = index;
        setDialog(owners[ownerActivePage - 1][index]);
        setIsEditingOwner(false);
        setOwnerEditFiles({});
    };

    const closeDialog = () => {
        dialogIndex = 0;
        setDialog(false);
        setIsEditingOwner(false);
        setOwnerEditFiles({});
    };

    const [isEditingOwner, setIsEditingOwner] = useState(false);
    const [ownerEditForm, setOwnerEditForm] = useState({});
    const [ownerEditFiles, setOwnerEditFiles] = useState({});
    const [savingOwner, setSavingOwner] = useState(false);

    const startEditOwner = () => {
        setOwnerEditForm({
            fullname: dialog.fullname || '',
            shopName: dialog.shopName || '',
            mobile: dialog.mobile || '',
            email: dialog.email || '',
            station: dialog.station || '',
            stallType: dialog.stallType || '',
            category: dialog.category || '',
            startingDate: dialog.startingDate
                ? dialog.startingDate.slice(0, 10)
                : '',
            endingDate: dialog.endingDate
                ? dialog.endingDate.slice(0, 10)
                : '',
            department: dialog.department || 'Catering',
        });
        setOwnerEditFiles({});
        setIsEditingOwner(true);
    };

    const cancelEditOwner = () => {
        setIsEditingOwner(false);
        setOwnerEditFiles({});
    };

    const handleOwnerEditFormChange = (e) => {
        setOwnerEditForm((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleOwnerEditFileChange = (e) => {
        const { name, files } = e.target;
        if (files && files[0]) {
            setOwnerEditFiles((prev) => ({ ...prev, [name]: files[0] }));
        }
    };

    const ownerDocumentUploadRoutes = {
        photo: 'photo',
        idPhoto: 'idProof',
        shopPhoto: 'shopPhoto',
        signPhoto: 'signaturePhoto',
        stampPhoto: 'stampPhoto',
    };

    const saveOwnerEdits = async () => {
        setSavingOwner(true);
        try {
            await axios.put(
                `${userBaseUrl}/owners/details/${dialog.id}`,
                ownerEditForm,
                { headers: { 'access-token': accessToken } }
            );

            const uploadTasks = [];

            for (const key of Object.keys(ownerDocumentUploadRoutes)) {
                if (!ownerEditFiles[key]) continue;
                const path = ownerDocumentUploadRoutes[key];
                const formData = new FormData();
                formData.append('image', ownerEditFiles[key]);
                uploadTasks.push(
                    axios.put(
                        `${userBaseUrl}/owners/${path}/${dialog.id}`,
                        formData,
                        { headers: { 'access-token': accessToken } }
                    )
                );
            }

            await Promise.all(uploadTasks);

            setIsEditingOwner(false);
            setOwnerEditFiles({});
            closeDialog();
            getOwners();
            socket.emit('updateOwner', { message: 'updateOwner' });
        } catch (err) {
            console.log(err);
            alert('Failed to update contractor. Please try again.');
        }
        setSavingOwner(false);
    };

    const getOwners = async () => {
        setIsRefreshing(true);

        try {
            const res = await axios.get(`${baseUrl}/owners`, {
                headers: {
                    'access-token': accessToken,
                },
            });

            if (!auth(res.data.message)) return;

            if (res.data) {
                let vendorsArray =
                    (localStorage.getItem('admin') == null ||
                        localStorage.getItem('admin') == '') &&
                    (localStorage.getItem('employee') != null ||
                        localStorage.getItem('employee') != '')
                        ? filterOwnersByStation(res.data)
                        : filterOwnersByDepartment(res.data);
                vendorsArray = applyDepartmentView(vendorsArray);

                const arrayData = [];
                for (const data of vendorsArray) {
                    arrayData.unshift(data);
                }

                let array = arrayData;
                let mainArray = [];

                let n = 0;
                for (
                    let i = 0;
                    i < Math.ceil(array.length / ownerItemsPerPage);
                    i++
                ) {
                    mainArray.push([]);
                    for (let a = 0; a < ownerItemsPerPage; a++) {
                        if (array[n] != undefined) {
                            mainArray[i].push(array[n]);
                            n++;
                        }
                    }
                }

                setOwners(mainArray);
                setOwnerTotalItems(res.data.length);

                setTotalItems(mainArray.length);
                setNotFound(false);
            } else {
                setNotFound(true);
            }

            setBuffer(false);

            setTimeout(() => {
                setTimeout(() => {
                    setFetchComplete(false);
                }, 2000);
                setFetchComplete(true);
                setIsRefreshing(false);
            }, 1000);
        } catch (err) {
            console.log(err);
        }
    };

    const getStations = async () => {
        try {
            const res = await axios.get(`${baseUrl}/stations`);
            setStations(res.data);
        } catch (error) {
            console.log(error);
        }

        setNotFound(false);
        setBuffer(false);
    };

    useEffect(() => {
        getOwners();
        getStations();

        socket.on('isOwnerUpdated', (data) => {
            if (searchTextField.length === 0) {
                getOwners();
            }
        });

        // let callData = setInterval(() => {
        //     getOwners();
        // }, 1000 * 5);

        // return () => {
        //     clearInterval(callData);
        // }
    }, []);

    const isFirstDepartmentRender = useRef(true);

    useEffect(() => {
        if (isFirstDepartmentRender.current) {
            isFirstDepartmentRender.current = false;
            return;
        }
        getOwners();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [departmentView]);

    // owners.forEach((owner, index) => {
    //     console.log(`Owner ${index + 1}:`, owner);
    //   });

    const sort = async (table, column, order) => {
        setLoader(true);
        let thisArray = await sortTable(table, column, order);

        // const arrayData = [];
        // for (const data of array) {
        // 	arrayData.unshift(data);
        // }
        // setOwners([...arrayData]);
        let vendorsArray =
            (localStorage.getItem('admin') == null ||
                localStorage.getItem('admin') == '') &&
            (localStorage.getItem('employee') != null ||
                localStorage.getItem('employee') != '')
                ? filterOwnersByStation(thisArray)
                : filterOwnersByDepartment(thisArray);
        vendorsArray = applyDepartmentView(vendorsArray);

        const arrayData = [];
        for (const data of vendorsArray) {
            arrayData.unshift(data);
        }

        let array = arrayData;
        let mainArray = [];

        let n = 0;
        for (let i = 0; i < Math.ceil(array.length / ownerItemsPerPage); i++) {
            mainArray.push([]);
            for (let a = 0; a < ownerItemsPerPage; a++) {
                if (array[n] != undefined) {
                    mainArray[i].push(array[n]);
                    n++;
                }
            }
        }

        setOwners(mainArray);
        setOwnerTotalItems(thisArray.length);

        setTotalItems(mainArray.length);
        setLoader(false);
    };

    const getPageNumberOwner = (number) => {
        setOwnerActivePage(number);
    };

    const viewVendors = async (ownerId, shopName) => {
        navigate('/owners/vendors', {
            state: { ownerId: ownerId, shopName: shopName },
        });
    };

    const handleChange = (e) => {
        setSearchText((prev) => ({ ...prev, search: e.target.value }));
    };

    const search = async () => {
        if (searchText.search.length !== 0 && searchText.search.length < 255) {
            try {
                setNotFound(true);
                setBuffer(true);
                const res = await axios.post(
                    `${baseUrl}/owners/search`,
                    searchText,
                    {
                        headers: {
                            'access-token': accessToken,
                        },
                    }
                );

                if (!auth(res.data.message)) return;

                if (res.data) {
                    if (res.data.length === 0) {
                        setNotFound(false);
                        setBuffer(false);
                        setTimeout(() => {
                            alert(`No results for "${searchText.search}".`);
                        }, 10);
                        return;
                    }

                    let vendorsArray =
                        (localStorage.getItem('admin') == null ||
                            localStorage.getItem('admin') == '') &&
                        (localStorage.getItem('employee') != null ||
                            localStorage.getItem('employee') != '')
                            ? filterOwnersByStation(res.data)
                            : filterOwnersByDepartment(res.data);
                    vendorsArray = applyDepartmentView(vendorsArray);

                    const arrayData = [];
                    for (const data of vendorsArray) {
                        arrayData.unshift(data);
                    }

                    let array = arrayData;
                    let mainArray = [];

                    let n = 0;
                    for (
                        let i = 0;
                        i < Math.ceil(array.length / ownerItemsPerPage);
                        i++
                    ) {
                        mainArray.push([]);
                        for (let a = 0; a < ownerItemsPerPage; a++) {
                            if (array[n] != undefined) {
                                mainArray[i].push(array[n]);
                                n++;
                            }
                        }
                    }

                    setOwners(mainArray);
                    setOwnerTotalItems(res.data.length);

                    setTotalItems(mainArray.length);
                    setNotFound(false);
                } else {
                    setNotFound(true);
                }
                setBuffer(false);
                searchTextField = searchText.search;
                hightlight(searchTextField);

                // setSearchText((prev) => ({ ...prev, search: '' }));
                // searchTextField = searchText.search;
            } catch (err) {
                console.log(err);
            }
            return;
        } else if (
            searchText.search.length !== 0 &&
            searchText.search.length > 255
        ) {
            alert('Search text is too big to search.');
            return;
        } else {
            alert("Can't search, search field is empty.");
            return;
        }
    };

    // const changeVendorsCount = async (ownerId, vendorsCount) => {
    //     let value = window.prompt('Total Vendors Count', vendorsCount);

    //     const data = {
    //         id: ownerId,
    //         vendorsCount: value,
    //     }

    //     if (value) {
    //         try {
    //             setNotFound(true);
    //             setBuffer(true);
    //             const res = await axios.put(`${baseUrl}/owners/updateVendorsCount`, data, {
    //                 headers: {
    //                     'access-token': accessToken
    //                 }
    //             });

    //             if (!auth(res.data.message)) return;

    //             if (res.data) {
    //                 getOwners();
    //             } else {
    //                 setNotFound(true);
    //             }
    //             setBuffer(false);
    //         } catch (err) {
    //             console.log(err);
    //         }
    //     }
    // }

    const changeStallTrolleyVendorCount = async (
        ownerId,
        stallTrolleyVendorCount
    ) => {
        let value = window.prompt(
            'Update number of staff',
            stallTrolleyVendorCount
        );

        const data = {
            id: ownerId,
            stallTrolleyVendorCount: value,
            adminId: JSON.parse(localStorage.getItem('admin')).id,
        };

        if (value) {
            try {
                // setNotFound(true);
                // setBuffer(true);
                setLoader(true);
                const res = await axios.put(
                    `${baseUrl}/owners/updateStallTrolleyVendorCount`,
                    data,
                    {
                        headers: {
                            'access-token': accessToken,
                        },
                    }
                );
                setLoader(false);

                if (!auth(res.data.message)) return;

                if (res.data) {
                    // getOwners();

                    for (let i = 0; i < owners.length; i++) {
                        for (let n = 0; n < owners[i].length; n++) {
                            if (owners[i][n].id === ownerId) {
                                setOwners((prev) => [
                                    ...prev,
                                    (prev[i][n].stallTrolleyVendorCount =
                                        value),
                                ]);
                            }
                        }
                    }

                    socket.emit('updateOwner', {
                        message: 'updateOwner',
                    });
                } else {
                    // setNotFound(true);
                }
                // setBuffer(false);
            } catch (err) {
                console.log(err);
            }
        }
    };

    const changePfVendorCount = async (ownerId, pfVendorCount) => {
        let value = window.prompt('Update PF vendors count', pfVendorCount);

        const data = {
            id: ownerId,
            pfVendorCount: value,
            adminId: JSON.parse(localStorage.getItem('admin')).id,
        };

        if (value) {
            try {
                // setNotFound(true);
                // setBuffer(true);
                setLoader(true);
                const res = await axios.put(
                    `${baseUrl}/owners/updatePfVendorCount`,
                    data,
                    {
                        headers: {
                            'access-token': accessToken,
                        },
                    }
                );
                setLoader(false);

                if (!auth(res.data.message)) return;

                if (res.data) {
                    // getOwners();

                    for (let i = 0; i < owners.length; i++) {
                        for (let n = 0; n < owners[i].length; n++) {
                            if (owners[i][n].id === ownerId) {
                                setOwners((prev) => [
                                    ...prev,
                                    (prev[i][n].pfVendorCount = value),
                                ]);
                            }
                        }
                    }

                    socket.emit('updateOwner', {
                        message: 'updateOwner',
                    });
                } else {
                    // setNotFound(true);
                }
                // setBuffer(false);
            } catch (err) {
                console.log(err);
            }
        }
    };



  

    const changeNumberOfStall = async (ownerId, numberOfStall) => {
        let value = window.prompt('Total number of stalls', numberOfStall);

        const data = {
            id: ownerId,
            numberOfStall: value,
            adminId: JSON.parse(localStorage.getItem('admin')).id,
        };

        if (value) {
            try {
                // setNotFound(true);
                // setBuffer(true);
                setLoader(true);
                const res = await axios.put(
                    `${baseUrl}/owners/updateNumberOfStall`,
                    data,
                    {
                        headers: {
                            'access-token': accessToken,
                        },
                    }
                );
                setLoader(false);

                if (!auth(res.data.message)) return;

                if (res.data) {
                    // setOwners('');

                    for (let i = 0; i < owners.length; i++) {
                        for (let n = 0; n < owners[i].length; n++) {
                            if (owners[i][n].id === ownerId) {
                                setOwners((prev) => [
                                    ...prev,
                                    (prev[i][n].numberOfStall = value),
                                ]);
                            }
                        }
                    }

                    socket.emit('updateOwner', {
                        message: 'updateOwner',
                    });
                } else {
                    // setNotFound(true);
                }
                // setBuffer(false);
            } catch (err) {
                console.log(err);
            }
        }
    };

    const changeNumberOfTrolley = async (ownerId, numberOfTrolley) => {
        let value = window.prompt('Total number of trolleys', numberOfTrolley);

        const data = {
            id: ownerId,
            numberOfTrolley: value,
            adminId: JSON.parse(localStorage.getItem('admin')).id,
        };

        if (value) {
            try {
                // setNotFound(true);
                // setBuffer(true);
                setLoader(true);
                const res = await axios.put(
                    `${baseUrl}/owners/updateNumberOfTrolley`,
                    data,
                    {
                        headers: {
                            'access-token': accessToken,
                        },
                    }
                );
                setLoader(false);

                if (!auth(res.data.message)) return;

                if (res.data) {
                    // getOwners();

                    for (let i = 0; i < owners.length; i++) {
                        for (let n = 0; n < owners[i].length; n++) {
                            if (owners[i][n].id === ownerId) {
                                setOwners((prev) => [
                                    ...prev,
                                    (prev[i][n].numberOfTrolley = value),
                                ]);
                            }
                        }
                    }

                    socket.emit('updateOwner', {
                        message: 'updateOwner',
                    });
                } else {
                    // setNotFound(true);
                }
                // setBuffer(false);
            } catch (err) {
                console.log(err);
            }
        }
    };

    const changeMobile = async (value) => {
        let prevMobile = value.mobile;
        let mobileValue = window.prompt(
            `Change mobile no. of contractor named '${value.name}'.`,
            value.mobile
        );

        const data = {
            id: value.id,
            mobile: mobileValue,
            adminId: JSON.parse(localStorage.getItem('admin')).id,
        };

        if (mobileValue && prevMobile != mobileValue) {
            try {
                // setNotFound(true);
                // setBuffer(true);
                setLoader(true);
                const res = await axios.put(
                    `${baseUrl}/owners/updateMobile`,
                    data,
                    {
                        headers: {
                            'access-token': accessToken,
                        },
                    }
                );
                setLoader(false);

                if (!auth(res.data.message)) return;

                if (res.data) {
                    // getOwners();

                    for (let i = 0; i < owners.length; i++) {
                        for (let n = 0; n < owners[i].length; n++) {
                            if (owners[i][n].id === value.id) {
                                setOwners((prev) => [
                                    ...prev,
                                    (prev[i][n].mobile = mobileValue),
                                ]);
                            }
                        }
                    }

                    socket.emit('updateOwner', {
                        message: 'updateOwner',
                    });
                } else {
                    // setNotFound(true);
                }
                // setBuffer(false);
            } catch (err) {
                console.log(err);
            }
        }
    };

    const changeEndingDate = async (value) => {
        let prevEndingDate = value.endingDate;
        let endingDateValue = window.prompt(
            `Change ending date of contractor named '${value.name}'. (Note: please enter date in YYYY-MM-DD format)`,
            value.endingDate
        );

        const data = {
            id: value.id,
            endingDate: endingDateValue,
            adminId: JSON.parse(localStorage.getItem('admin')).id,
        };

        if (endingDateValue && prevEndingDate != endingDateValue) {
            try {
                // setNotFound(true);
                // setBuffer(true);
                setLoader(true);
                const res = await axios.put(
                    `${baseUrl}/owners/updateEndingdate`,
                    data,
                    {
                        headers: {
                            'access-token': accessToken,
                        },
                    }
                );
                setLoader(false);

                if (!auth(res.data.message)) return;

                if (res.data) {
                    // getOwners();

                    for (let i = 0; i < owners.length; i++) {
                        for (let n = 0; n < owners[i].length; n++) {
                            if (owners[i][n].id === value.id) {
                                setOwners((prev) => [
                                    ...prev,
                                    (prev[i][n].endingDate = endingDateValue),
                                ]);
                            }
                        }
                    }

                    socket.emit('updateOwner', {
                        message: 'updateOwner',
                    });
                } else {
                    // setNotFound(true);
                }
                // setBuffer(false);
            } catch (err) {
                console.log(err);
            }
        }
    };

    // const getRemainingDays = (endingDate) => {
    //     const date1 = new Date();
    //     const date2 = new Date(endingDate);
    //     const diffTime = Math.abs(date2 - date1);
    //     const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    //     if ((date2 - date1).toString()[0] == '-') {
    //         return {
    //             className: 'warning-container strong',
    //             label: `Contractor's validity expired ${diffDays - 1} days ago.`,
    //         };
    //     }

    //     if (diffDays < 1) {
    //         return {
    //             className: 'warning-container strong',
    //             label: `Contractor's validity expired.`,
    //         };
    //     }

    //     if (diffDays < 15) {
    //         return {
    //             className: 'warning-container strong',
    //             label: `${diffDays} days remaining.`,
    //         };
    //     }

    //     return {
    //         className: 'warning-container',
    //         label: `${diffDays} days remaining.`,
    //     };
    // }


    // const activeSM = async (vendorId, vendorName) => {
	// 	let isEmployee = localStorage.getItem('employee') ? true : false;
	
	// 	if (isEmployee) {
	// 		let employee = JSON.parse(localStorage.getItem('employee'));
	// 		let accessToken = employee?.accessToken;
	// 		let updaterId = employee?.id;
	
	// 		if (!vendorId || !vendorName) {
	// 			alert("Invalid vendor details.");
	// 			return;
	// 		}
	
	// 		if (
	// 			window.confirm(
	// 				`Are you sure you want to activate this vendor with name '${vendorName}'? This process is non-reversible.`
	// 			)
	// 		) {
	// 			try {
	// 				setNotFound(true); // Assuming it's a loading state
	// 				setBuffer(true); // Assuming it's a buffer state
	
	// 				let data = {
	// 					updatedBy: 'employees',
	// 					updaterId: updaterId,
	// 					stMaster: 1, // Setting stMaster to 1 to mark the vendor as active
	// 				};
	
	// 				// Making a PUT request to update the vendor's stMaster status to 1
	// 				const res = await axios.put(
	// 					`${userBaseUrl}/vendors/activate/${vendorId}`,
	// 					data,
	// 					{
	// 						headers: {
	// 							'access-token': accessToken,
	// 						},
	// 					}
	// 				);
	
	// 				if (!auth(res.data.message)) return;
	
	// 				if (res.data) {
	// 					getVendors(); // Fetch updated list of vendors
	// 					setNotFound(false); // End loading state
	// 					socket.emit('updateVendors', {
	// 						message: 'updateVendors',
	// 					});
	// 				} else {
	// 					setNotFound(true); // Set NotFound if something goes wrong
	// 					alert('Vendor not found or activation failed.');
	// 				}
	// 				setBuffer(false); // End buffer state
	// 				console.log("Vendor activated successfully.");
	// 			} catch (err) {
	// 				setBuffer(false); // End buffer state if an error occurs
	// 				console.log("Error during activation:", err);
	// 				setNotFound(true); // End loading state
	// 				alert('Failed to activate vendor. Please try again later.');
	// 			}
	// 		}
	// 	} else {
	// 		alert('You must be an employee to perform this action.');
	// 	}
	// };
	


    const changeStatus = async (id, status) => {
        if (status == 0) {
            if (!window.confirm('Do you want to approve this contractor?'))
                return;
        }
        if (status == 1) {
            if (!window.confirm('Do you want to disapprove this contractor?'))
                return;
        }

        if (status == 0) {
            status = 1;
        } else {
            status = 0;
        }

        const data = {
            id: id,
            status: status,
            adminId: JSON.parse(localStorage.getItem('admin')).id,
        };
        try {
            // setNotFound(true);
            // setBuffer(true);
            setLoader(true);
            const res = await axios.post(
                `${baseUrl}/owners/changeStatus`,
                data,
                {
                    headers: {
                        'access-token': accessToken,
                    },
                }
            );
            const result = await axios.post(
                `${baseUrl}/owners/changeLoginStatus`,
                data,
                {
                    headers: {
                        'access-token': accessToken,
                    },
                }
            );
            
            setLoader(false);

            if (!auth(res.data.message)) return;

            if (res.data) {
                // setNotFound(false);
                // getOwners();

                for (let i = 0; i < owners.length; i++) {
                    for (let n = 0; n < owners[i].length; n++) {
                        if (owners[i][n].id === data.id) {
                            setOwners((prev) => [
                                ...prev,
                                (prev[i][n].approve = data.status),
                            ]);
                        }
                    }
                }

                socket.emit('updateOwner', {
                    message: 'updateOwner',
                });
            } else {
                // setNotFound(true);
            }
            // setBuffer(false);
        } catch (err) {
            console.log(err);
        }
    };

    const changePaymentStatus = async (id, status) => {
        const admin = JSON.parse(localStorage.getItem('admin'));
        const employee = JSON.parse(localStorage.getItem('employee'));
    
        // Check if the user is authorized (either an admin or an employee with SM designation)
        if (!admin && (!employee || employee.designation !== 'SM')) {
            alert('You are not authorized to perform this action.');
            return;
        }
    
        // Confirmation prompts
        if (status === 0) {
            if (!window.confirm('Do you want to approve this contractor?')) return;
        } else if (status === 1) {
            if (!window.confirm('Do you want to disapprove this contractor?')) return;
        }
    
        // Toggle the status
        status = status === 0 ? 1 : 0;
    
        const data = {
            id: id,
            status: status,
            adminId: admin ? admin.id : null,
            employeeId:employee ? employee.id : null // Use admin ID if available
        };
    
        try {
            setLoader(true);
    
            const res = await axios.post(
                `${baseUrl}/owners/changePaymentStatus`,
                data,
                {
                    headers: {
                        'access-token': accessToken,
                    },
                }
            );
    
            setLoader(false);
    
            if (!auth(res.data.message)) return;
    
            if (res.data) {
                // Update the owners' status locally
                setOwners((prevOwners) =>
                    prevOwners.map((group) =>
                        group.map((owner) =>
                            owner.id === data.id
                                ? { ...owner, payed: data.status }
                                : owner
                        )
                    )
                );
    
                // Emit a socket event to update the owner
                socket.emit('updateOwner', {
                    message: 'updateOwner',
                });
            }
        } catch (err) {
            console.error(err);
        }
    };
    


    const changeLoginApprovalStatus = async (id, status) => {
        if (status == 0) {
            if (!window.confirm('Do you want to approve this contractor?'))
                return;
        }
        if (status == 1) {
            if (!window.confirm('Do you want to diapprove this contractor?'))
                return;
        }

        if (status == 0) {
            status = 1;
        } else {
            status = 0;
        }

        const data = {
            id: id,
            status: status,
            adminId: JSON.parse(localStorage.getItem('admin')).id,
        };

        try {
            // setNotFound(true);
            // setBuffer(true);
            setLoader(true);
            const res = await axios.post(
                `${baseUrl}/owners/changeLoginApprovalStatus`,
                data,
                {
                    headers: {
                        'access-token': accessToken,
                    },
                }
            );
            setLoader(false);

            if (!auth(res.data.message)) return;

            if (res.data) {
                // setNotFound(false);
                // getOwners();

                for (let i = 0; i < owners.length; i++) {
                    for (let n = 0; n < owners[i].length; n++) {
                        if (owners[i][n].id === data.id) {
                            setOwners((prev) => [
                                ...prev,
                                (prev[i][n].login = data.status),
                            ]);
                        }
                    }
                }

                socket.emit('updateOwner', {
                    message: 'updateOwner',
                });
            } else {
                // setNotFound(true);
            }
            // setBuffer(false);
        } catch (err) {
            console.log(err);
        }
    };

    

    const changeRPFApprovalStatus = async (id, status) => {
        if (status == 0) {
            if (!window.confirm('Do you want to approve this contractor?'))
                return;
        }
        if (status == 1) {
            if (!window.confirm('Do you want to diapprove this contractor?'))
                return;
        }

        if (status == 0) {
            status = 1;
        } else {
            status = 0;
        }

        const data = {
            id: id,
            status: status,
            adminId: JSON.parse(localStorage.getItem('admin')).id,
        };

        try {
            // setNotFound(true);
            // setBuffer(true);
            setLoader(true);
            const res = await axios.post(
                `${baseUrl}/owners/changeRPFApprovalStatus`,
                data,
                {
                    headers: {
                        'access-token': accessToken,
                    },
                }
            );
            setLoader(false);

            if (!auth(res.data.message)) return;

            if (res.data) {
                // setNotFound(false);
                // getOwners();

                for (let i = 0; i < owners.length; i++) {
                    for (let n = 0; n < owners[i].length; n++) {
                        if (owners[i][n].id === data.id) {
                            setOwners((prev) => [
                                ...prev,
                                (prev[i][n].ipf = data.status),
                            ]);
                        }
                    }
                }

                socket.emit('updateOwner', {
                    message: 'updateOwner',
                });
            } else {
                // setNotFound(true);
            }
            // setBuffer(false);
        } catch (err) {
            console.log(err);
        }
    };



    const toggleStatus = async (ownerId, isDisabled, ownerName) => {
        if (isDisabled == '0') {
            if (
                !window.confirm(
                    `Are you sure you want to disable contractor with name '${ownerName}'?`
                )
            )
                return;
            // if (
            //     window.prompt(
            //         `Enter contractor name '${ownerName}' to disable.`
            //     ) !== ownerName
            // ) {
            //     alert('Wrong input. Contractor not disabled');
            //     return;
            // }
        }

        if (isDisabled == '1') {
            if (
                !window.confirm(
                    `Are you sure you want to enable contractor with name '${ownerName}'?`
                )
            )
                return;
            // if (
            //     window.prompt(
            //         `Enter contractor name '${ownerName}' to enable.`
            //     ) !== ownerName
            // ) {
            //     alert('Wrong input. Contractor not enabled');
            //     return;
            // }
        }

        const data = {
            adminId: JSON.parse(localStorage.getItem('admin')).id,
        };

        try {
            setNotFound(true);
            setBuffer(true);
            const res = await axios.put(
                `${baseUrl}/owners/disable/${ownerId}`,
                data,
                {
                    headers: {
                        'access-token': accessToken,
                    },
                }
            );

            if (!auth(res.data.message)) return;

            if (res.data) {
                getOwners();
                setNotFound(false);

                socket.emit('updateOwner', {
                    message: 'updateOwner',
                });
            } else {
                setNotFound(true);
            }
            setBuffer(false);
        } catch (err) {
            console.log(err);
        }
    };

    // const deleteOwner = async (ownerId, ownerName) => {
    //     if (
    //         window.confirm(
    //             `Are you sure you want to permanently delete contractor with name '${ownerName}'? This process is non-reversal.`
    //         )
    //     ) {
    //         // if (
    //         //     window.prompt(
    //         //         `Enter contractor name '${ownerName}' to delete permanently.`
    //         //     ) !== ownerName
    //         // ) {
    //         //     alert('Wrong input. Contractor not deleted');
    //         //     return;
    //         // }

    //         try {
    //             // setNotFound(true);
    //             // setBuffer(true);

    //             const data = {
    //                 adminId: JSON.parse(localStorage.getItem('admin')).id,
    //             };

    //             setLoader(true);
    //             // const res = await axios.put(
    //             //     `${baseUrl}/owners/delete/${ownerId}`,
    //             //     data,
    //             //     {
    //             //         headers: {
    //             //             'access-token': accessToken,
    //             //         },
    //             //     }
    //             // );
    //             const res = await axios.delete(
    //                 `${baseUrl}/owners/delete/${ownerId}`,
    //                 data,
    //                 {
    //                     headers: {
    //                         'access-token': accessToken,
    //                     },
    //                 }
    //             );
    //             setLoader(false);

    //             if (!auth(res.data.message)) return;

    //             if (res.data) {
    //                 // setNotFound(false);
    //                 // getOwners();

    //                 for (let i = 0; i < owners.length; i++) {
    //                     for (let n = 0; n < owners[i].length; n++) {
    //                         if (owners[i][n].id === ownerId) {
    //                             setOwners((prev) => [
    //                                 ...prev,
    //                                 (prev[i][n].isDeleted = 1),
    //                             ]);
    //                         }
    //                     }
    //                 }

    //                 getOwners()

    //                 socket.emit('updateOwner', {
    //                     message: 'updateOwner',
    //                 });
    //             } else {
    //                 // setNotFound(true);
    //             }
    //             // setBuffer(false);
    //         } catch (err) {
    //             console.log(err);
    //         }
    //     }
    // };


    const deleteOwner = async (ownerId, ownerName) => {
        if (
            window.confirm(
                `Are you sure you want to permanently delete contractor with the name '${ownerName}'? This process is irreversible.`
            )
        ) {
            try {
                const adminData = JSON.parse(localStorage.getItem('admin'));
                if (!adminData || !adminData.id) {
                    alert('Admin information is missing. Please log in again.');
                    return;
                }
    
                const data = { adminId: adminData.id }; // Include adminId in the request
    
                setLoader(true);
    
                const res = await axios.delete(`${baseUrl}/owners/delete/${ownerId}`, {
                    headers: {
                        'access-token': accessToken,
                    },
                    data, // Pass the adminId in the DELETE request body
                });
    
                setLoader(false);
    
                if (res.status === 200) {
                    // Update UI state after successful deletion
                    setOwners((prevOwners) =>
                        prevOwners.map((ownerGroup) =>
                            ownerGroup.map((owner) =>
                                owner.id === ownerId
                                    ? { ...owner, isDeleted: 1 }
                                    : owner
                            )
                        )
                    );
    
                    // Optionally, refetch the owners
                    getOwners();
    
                    // Notify server about the update
                    socket.emit('updateOwner', {
                        message: 'Owner deleted',
                    });
    
                    alert(`Contractor '${ownerName}' has been successfully deleted.`);
                } else {
                    alert('Failed to delete the contractor. Please try again.');
                }
            } catch (err) {
                console.error('Error deleting owner:', err);
                setLoader(false);
    
                // Handle authentication or API errors
                if (err.response?.status === 401 || err.response?.status === 403) {
                    alert('Session expired. Please log in again.');
                    window.location.href = '/login'; // Redirect on authentication failure
                } else {
                    alert(
                        'An error occurred while deleting the contractor. Please try again.'
                    );
                }
            }
        }
    };
    
    
    
    const enterClick = (e) => {
        if (e.key === 'Enter' || e.keyCode === 13) {
            let button = document.getElementById('on-enter');
            button.click();
        }
    };

    // const totalCount = () => {
    // 	let count = 0;
    // 	for (let i = 0; i < owners.length; i++) {
    // 		count = count + owners[i].length;
    // 	}
    // 	return count;
    // };

    useEffect(() => {
        document.addEventListener('keyup', (e) => {
            if (e.key !== '/') return;
            let searchInput = document.getElementById('search-input');
            searchInput.focus();
        });
    }, []);

    // const sortByStation = (station) => {
    // 	if (station !== '*') {
    // 		search('Bhus');
    // 	} else {
    // 		getOwners();
    // 	}
    // };

    const updateStallLocation = async (ownerId, shopAddress, adminId) => {
        let value = window.prompt('Update stall location', shopAddress);
        // closeDialog();

        if (value) {
            const data = {
                id: ownerId,
                shopAddress: value,
                adminId: adminId,
            };
            try {
                // setNotFound(true);
                setLoader(true);
                const res = await axios.put(
                    `${baseUrl}/owners/updateShopAddress`,
                    data,
                    {
                        headers: {
                            'access-token': accessToken,
                        },
                    }
                );
                setLoader(false);

                if (!auth(res.data.message)) return;

                if (res.data) {
                    // getOwners();
                    setDialog((prev) => ({ ...prev, shopAddress: value }));

                    socket.emit('updateOwner', {
                        message: 'updateOwner',
                    });
                } else {
                    // setNotFound(true);
                }
                // openDialog(dialogIndex);
                // setBuffer(false);
            } catch (err) {
                console.log(err);
            }
        }
    };

    return (
        <>
            <Header />
            <div className='screen-container'>
                <Navigation />
                <div className='side-container'>
                    {buffer && notFound ? <Buffer /> : <></>}

                    {owners.length === 0 && !buffer ? (
                        <Fallback
                            title='Not found'
                            text='No data found in the database. Try refreshing the page.'
                        />
                    ) : (
                        <></>
                    )}

                    {owners.length !== 0 && !notFound && !buffer ? (
                        <>
                            <div className='screen-title headline-large'>
                                Contractors
                            </div>

                            {isSuperAdmin && (
                                <div className='department-tabs'>
                                    {['All', 'Catering', 'Other'].map(
                                        (view) => (
                                            <button
                                                key={view}
                                                type='button'
                                                className={
                                                    departmentView === view
                                                        ? 'department-tab active'
                                                        : 'department-tab'
                                                }
                                                onClick={() =>
                                                    selectDepartmentView(view)
                                                }
                                            >
                                                {view}
                                            </button>
                                        )
                                    )}
                                </div>
                            )}

                            <div className='search-container'>
                                <input
                                    type='text'
                                    className='body-medium'
                                    id='search-input'
                                    onChange={handleChange}
                                    placeholder='Search here (press "/" to focus)'
                                    onKeyUp={(event) => enterClick(event)}
                                    defaultValue={searchText.search}
                                />
                                <button
                                    disabled={isRefreshing}
                                    className={
                                        isRefreshing
                                            ? 'icon-button refreshing'
                                            : 'icon-button'
                                    }
                                    onClick={() => {
                                        searchTextField = '';
                                        setSearchText((prev) => ({
                                            ...prev,
                                            search: '',
                                        }));

                                        document.getElementById(
                                            'search-input'
                                        ).value = '';

                                        getOwners();
                                    }}
                                    title='Reload'
                                >
                                    {fetchComplete ? (
                                        <CheckCircle />
                                    ) : (
                                        <Refresh />
                                    )}
                                </button>
                                <button
                                    type='button'
                                    id='on-enter'
                                    className='filled-tonal-button'
                                    onClick={() => search(searchText.search)}
                                >
                                    Search
                                </button>
                            </div>

                            {/* <div className="sorting-container">
								<select
									className="sorting-button label-large"
									onChange={(event) =>
										sortByStation(event.currentTarget.value)
									}
								>
									<option
										className="label-large"
										value="*"
									>
										All stations
									</option>
									{stations.map((data) => {
										return (
											<option
												value={data.station}
												key={data.station}
											>
												{data.station}
											</option>
										);
									})}
								</select>
							</div> */}

                            <div className='table-container center'>
                                <table>
                                    {/* <tbody> */}
                                    <thead>
                                        <tr>
                                            <th className='left-box'>
                                                <div className='table-head'>
                                                    <div className='table-title'>
                                                        Sr.&nbsp;No.
                                                    </div>
                                                </div>
                                            </th>
                                            <th>
                                                <div className='table-head'>
                                                    <div className='table-title'>
                                                        Photo
                                                    </div>
                                                </div>
                                            </th>
                                            {/* <th>
                                                    <div className='table-head'>
                                                        <div className='table-title'>Photo</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className='table-head'>
                                                        <div className='table-title'>Id&nbsp;Photo</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className='table-head'>
                                                        <div className='table-title'>Shop&nbsp;Photo</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className='table-head'>
                                                        <div className='table-title'>Sign&nbsp;Photo</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className='table-head'>
                                                        <div className='table-title'>Stamp&nbsp;Photo</div>
                                                    </div>
                                                </th> */}
                                            <th>
                                                <div className='table-head'>
                                                    <div className='table-title'>
                                                        Stall&nbsp;name
                                                    </div>
                                                    {(localStorage.getItem(
                                                        'admin'
                                                    ) != null ||
                                                        localStorage.getItem(
                                                            'admin'
                                                        ) != '') &&
                                                        (localStorage.getItem(
                                                            'employee'
                                                        ) == null ||
                                                            localStorage.getItem(
                                                                'employee'
                                                            ) == '') && (
                                                            <div className='sort-container'>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by ascending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'fullname',
                                                                            'ASC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandLess />
                                                                </button>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by descending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'fullname',
                                                                            'DESC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandMore />
                                                                </button>
                                                            </div>
                                                        )}
                                                </div>
                                            </th>
                                            {/* <th>
                                                    <div className='table-head'>
                                                        <div className='table-title'>Shop&nbsp;address</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className='table-head'>
                                                        <div className='table-title'>Shop&nbsp;name</div>
                                                        <div className='sort-container'>
                                                            <button className='sort-button' onClick={() => sort('owners', 'shopName', 'ASC')}><ExpandLess /></button>
                                                            <button className='sort-button' onClick={() => sort('owners', 'shopName', 'DESC')}><ExpandMore /></button>
                                                        </div>
                                                    </div>
                                                </th> */}
                                            {/* <th>
                                                    <div className='table-head'>
                                                        <div className='table-title'>Vendors Count</div>
                                                    </div>
                                                </th> */}

                                            <th>
                                                {/* <div className='table-head'>
                                                        <div className='table-title'>Station</div>
                                                    </div> */}
                                                <div className='table-head'>
                                                    <div className='table-title'>
                                                        Station
                                                    </div>
                                                    {(localStorage.getItem(
                                                        'admin'
                                                    ) != null ||
                                                        localStorage.getItem(
                                                            'admin'
                                                        ) != '') &&
                                                        (localStorage.getItem(
                                                            'employee'
                                                        ) == null ||
                                                            localStorage.getItem(
                                                                'employee'
                                                            ) == '') && (
                                                            <div className='sort-container'>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by ascending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'station',
                                                                            'ASC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandLess />
                                                                </button>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by descending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'station',
                                                                            'DESC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandMore />
                                                                </button>
                                                            </div>
                                                        )}
                                                </div>
                                            </th>

                                            <th>
                                            <div className='table-head'>
                                                    <div className='table-title'>
                                                        Stall Type
                                                    </div>
                                            </div>
                                            </th>

                                            <th>
                                            <div className='table-head'>
                                                    <div className='table-title'>
                                                        Department
                                                    </div>
                                            </div>
                                            </th>

                                            <th className='col-fit'>
                                                {/* <div className='table-head'>
                                                        <div className='table-title'>Number of stalls</div>
                                                    </div> */}
                                                <div className='table-head'>
                                                    <div className='table-title'>
                                                        Number of stalls
                                                    </div>
                                                    {(localStorage.getItem(
                                                        'admin'
                                                    ) != null ||
                                                        localStorage.getItem(
                                                            'admin'
                                                        ) != '') &&
                                                        (localStorage.getItem(
                                                            'employee'
                                                        ) == null ||
                                                            localStorage.getItem(
                                                                'employee'
                                                            ) == '') && (
                                                            <div className='sort-container'>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by ascending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'numberOfStall',
                                                                            'ASC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandLess />
                                                                </button>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by descending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'numberOfStall',
                                                                            'DESC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandMore />
                                                                </button>
                                                            </div>
                                                        )}
                                                </div>
                                            </th>

                                            <th className='col-fit'>
                                                {/* <div className='table-head'>
                                                        <div className='table-title'>Number of trolleys</div>
                                                    </div> */}
                                                <div className='table-head'>
                                                    <div className='table-title'>
                                                        Number of trolleys
                                                    </div>
                                                    {(localStorage.getItem(
                                                        'admin'
                                                    ) != null ||
                                                        localStorage.getItem(
                                                            'admin'
                                                        ) != '') &&
                                                        (localStorage.getItem(
                                                            'employee'
                                                        ) == null ||
                                                            localStorage.getItem(
                                                                'employee'
                                                            ) == '') && (
                                                            <div className='sort-container'>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by ascending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'numberOfTrolley',
                                                                            'ASC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandLess />
                                                                </button>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by descending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'numberOfTrolley',
                                                                            'DESC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandMore />
                                                                </button>
                                                            </div>
                                                        )}
                                                </div>
                                            </th>

                                            <th>
                                                {/* <div className='table-head'>
                                                        <div className='table-title'>Number of staff</div>
                                                    </div> */}
                                                <div className='table-head'>
                                                    <div className='table-title'>
                                                        Number of staff
                                                    </div>
                                                    {(localStorage.getItem(
                                                        'admin'
                                                    ) != null ||
                                                        localStorage.getItem(
                                                            'admin'
                                                        ) != '') &&
                                                        (localStorage.getItem(
                                                            'employee'
                                                        ) == null ||
                                                            localStorage.getItem(
                                                                'employee'
                                                            ) == '') && (
                                                            <div className='sort-container'>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by ascending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'stallTrolleyVendorCount',
                                                                            'ASC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandLess />
                                                                </button>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by descending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'stallTrolleyVendorCount',
                                                                            'DESC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandMore />
                                                                </button>
                                                            </div>
                                                        )}
                                                </div>
                                            </th>

                                            <th>
                                                {/* <div className='table-head'>
                                                        <div className='table-title'>PF vendor</div>
                                                    </div> */}
                                                <div className='table-head'>
                                                    <div className='table-title'>
                                                        PF vendor
                                                    </div>
                                                    {(localStorage.getItem(
                                                        'admin'
                                                    ) != null ||
                                                        localStorage.getItem(
                                                            'admin'
                                                        ) != '') &&
                                                        (localStorage.getItem(
                                                            'employee'
                                                        ) == null ||
                                                            localStorage.getItem(
                                                                'employee'
                                                            ) == '') && (
                                                            <div className='sort-container'>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by ascending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'pfVendorCount',
                                                                            'ASC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandLess />
                                                                </button>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by descending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'pfVendorCount',
                                                                            'DESC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandMore />
                                                                </button>
                                                            </div>
                                                        )}
                                                </div>
                                            </th>
                                            <th className='col-fit'>
                                                {/* <div className='table-head'>
                                                        <div className='table-title'>Supporting staff</div>
                                                    </div> */}
                                                <div className='table-head'>
                                                    <div className='table-title'>
                                                        Supporting staff
                                                    </div>
                                                    {(localStorage.getItem(
                                                        'admin'
                                                    ) != null ||
                                                        localStorage.getItem(
                                                            'admin'
                                                        ) != '') &&
                                                        (localStorage.getItem(
                                                            'employee'
                                                        ) == null ||
                                                            localStorage.getItem(
                                                                'employee'
                                                            ) == '') && (
                                                            <div className='sort-container'>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by ascending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'supportingStaff',
                                                                            'ASC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandLess />
                                                                </button>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by descending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'supportingStaff',
                                                                            'DESC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandMore />
                                                                </button>
                                                            </div>
                                                        )}
                                                </div>
                                            </th>
                                            <th>
                                                <div className='table-head'>
                                                    <div className='table-title'>
                                                        Total
                                                    </div>
                                                </div>
                                            </th>

                                            {/* <th>
                                                    <div className='table-head'>
                                                        <div className='table-title'>Username</div>
                                                        <div className='sort-container'>
                                                            <button className='sort-button' onClick={() => sort('owners', 'username', 'ASC')}><ExpandLess /></button>
                                                            <button className='sort-button' onClick={() => sort('owners', 'username', 'DESC')}><ExpandMore /></button>
                                                        </div>
                                                    </div>
                                                </th> */}
                                            {/* <th>
                                                    <div className='table-head'>
                                                        <div className='table-title'>Email</div>
                                                        <div className='sort-container'>
                                                            <button className='sort-button' onClick={() => sort('owners', 'email', 'ASC')}><ExpandLess /></button>
                                                            <button className='sort-button' onClick={() => sort('owners', 'email', 'DESC')}><ExpandMore /></button>
                                                        </div>
                                                    </div>
                                                </th> */}
                                            <th>
                                                <div className='table-head'>
                                                    <div className='table-title'>
                                                        Mobile
                                                    </div>
                                                    {(localStorage.getItem(
                                                        'admin'
                                                    ) != null ||
                                                        localStorage.getItem(
                                                            'admin'
                                                        ) != '') &&
                                                        (localStorage.getItem(
                                                            'employee'
                                                        ) == null ||
                                                            localStorage.getItem(
                                                                'employee'
                                                            ) == '') && (
                                                            <div className='sort-container'>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by ascending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'mobile',
                                                                            'ASC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandLess />
                                                                </button>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by descending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'mobile',
                                                                            'DESC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandMore />
                                                                </button>
                                                            </div>
                                                        )}
                                                </div>
                                            </th>
                                            {/* <th>
                                                    <div className='table-head'>
                                                        <div className='table-title'>Starting&nbsp;date</div>
                                                        <div className='sort-container'>
                                                            <button className='sort-button' onClick={() => sort('owners', 'startingDate', 'ASC')}><ExpandLess /></button>
                                                            <button className='sort-button' onClick={() => sort('owners', 'startingDate', 'DESC')}><ExpandMore /></button>
                                                        </div>
                                                    </div>
                                                </th> */}
                                            <th>
                                                <div className='table-head'>
                                                    <div className='table-title'>
                                                        Ending&nbsp;date
                                                    </div>
                                                    {(localStorage.getItem(
                                                        'admin'
                                                    ) != null ||
                                                        localStorage.getItem(
                                                            'admin'
                                                        ) != '') &&
                                                        (localStorage.getItem(
                                                            'employee'
                                                        ) == null ||
                                                            localStorage.getItem(
                                                                'employee'
                                                            ) == '') && (
                                                            <div className='sort-container'>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by ascending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'endingDate',
                                                                            'ASC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandLess />
                                                                </button>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by descending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'endingDate',
                                                                            'DESC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandMore />
                                                                </button>
                                                            </div>
                                                        )}
                                                </div>
                                            </th>
                                            {/* <th>
                                                    <div className='table-head'>
                                                        <div className='table-title'>Id</div>
                                                        <div className='sort-container'>
                                                            <button className='sort-button' onClick={() => sort('owners', 'id', 'ASC')}><ExpandLess /></button>
                                                            <button className='sort-button' onClick={() => sort('owners', 'id', 'DESC')}><ExpandMore /></button>
                                                        </div>
                                                    </div>
                                                </th> */}
                                            <th>
                                                <div className='table-head'>
                                                    <div className='table-title'>
                                                        Approval status
                                                    </div>
                                                </div>
                                            </th>


                                            {(localStorage.getItem('admin') ==
                                                null ||
                                                localStorage.getItem('admin') ==
                                                    '') &&
                                                (localStorage.getItem(
                                                    'employee'
                                                ) != null ||
                                                    localStorage.getItem(
                                                        'employee'
                                                    ) != '') && (
                                                    <th>
                                                        {/* <div className='table-head'>
                                                            <div className='table-title'>Login approval</div>
                                                        </div> */}
                                                        <div className='table-head'>
                                                            <div className='table-title'>
                                                                SD/SM
                                                            </div>
                                                            <div className='sort-container'>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by ascending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'approve',
                                                                            'ASC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandLess />
                                                                </button>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by descending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'approve',
                                                                            'DESC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandMore />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </th>
                                                )}












                                            {(localStorage.getItem('admin') !=
                                                null ||
                                                localStorage.getItem('admin') !=
                                                    '') &&
                                                (localStorage.getItem(
                                                    'employee'
                                                ) == null ||
                                                    localStorage.getItem(
                                                        'employee'
                                                    ) == '') && (
                                                    <th>
                                                        {/* <div className='table-head'>
                                                            <div className='table-title'>Login approval</div>
                                                        </div> */}
                                                        <div className='table-head'>
                                                            <div className='table-title'>
                                                                Admin approval
                                                            </div>
                                                            <div className='sort-container'>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by ascending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'approve',
                                                                            'ASC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandLess />
                                                                </button>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by descending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'approve',
                                                                            'DESC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandMore />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </th>
                                                )}

                                            

                                            {(localStorage.getItem('admin') !=
                                                null ||
                                                localStorage.getItem('admin') !=
                                                    '') &&
                                                (localStorage.getItem(
                                                    'employee'
                                                ) == null ||
                                                    localStorage.getItem(
                                                        'employee'
                                                    ) == '') &&
                                                JSON.parse(
                                                    localStorage.getItem(
                                                        'admin'
                                                    )
                                                ).superAdmin == 0 && (
                                                    <th>
                                                        {/* <div className='table-head'>
                                                            <div className='table-title'>Registration payment approval</div>
                                                        </div> */}
                                                        <div className='table-head'>
                                                            <div className='table-title'>
                                                            Documents Approved by SD/SM
                                                            </div>
                                                            <div className='sort-container'>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by ascending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'payed',
                                                                            'ASC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandLess />
                                                                </button>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by descending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'payed',
                                                                            'DESC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandMore />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </th>
                                                )}

                        {/* csci approval  */}

                                        {/* {(localStorage.getItem('admin') !=
                                                null ||
                                                localStorage.getItem('admin') !=
                                                    '') &&
                                                (localStorage.getItem(
                                                    'employee'
                                                ) == null ||
                                                    localStorage.getItem(
                                                        'employee'
                                                    ) == '') && (
                                                    <th>
                                                        
                                                        <div className='table-head'>
                                                            <div className='table-title'>
                                                                CCI approval
                                                            </div>
                                                            <div className='sort-container'>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by ascending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'approve',
                                                                            'ASC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandLess />
                                                                </button>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by descending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'approve',
                                                                            'DESC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandMore />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </th>
                                                )} */}

                        {/* ipf Approcal */}
                                    {/* {(localStorage.getItem('admin') !=
                                                null ||
                                                localStorage.getItem('admin') !=
                                                    '') &&
                                                (localStorage.getItem(
                                                    'employee'
                                                ) == null ||
                                                    localStorage.getItem(
                                                        'employee'
                                                    ) == '') && (
                                                    <th>
                                                      
                                                        <div className='table-head'>
                                                            <div className='table-title'>
                                                                RPF approval
                                                            </div>
                                                            <div className='sort-container'>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by ascending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'approve',
                                                                            'ASC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandLess />
                                                                </button>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by descending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'approve',
                                                                            'DESC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandMore />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </th>
                                                )} */}




                                            <th>
                                                <div className='table-head'>
                                                    <div className='table-title'>
                                                        View vendor
                                                    </div>
                                                </div>
                                            </th>
                                            <th>
                                                <div className='table-head'>
                                                    <div className='table-title'>
                                                        View contractors
                                                    </div>
                                                </div>
                                            </th>

                                            {(localStorage.getItem('admin') !=
                                                null ||
                                                localStorage.getItem('admin') !=
                                                    '') &&
                                                (localStorage.getItem(
                                                    'employee'
                                                ) == null ||
                                                    localStorage.getItem(
                                                        'employee'
                                                    ) == '') && (
                                                    <th>
                                                        {/* <div className='table-head'>
                                                            <div className='table-title'>Owner status</div>
                                                        </div> */}
                                                        <div className='table-head'>
                                                            <div className='table-title'>
                                                                Owner status
                                                            </div>
                                                            <div className='sort-container'>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by ascending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'isDisabled',
                                                                            'ASC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandLess />
                                                                </button>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by descending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'isDisabled',
                                                                            'DESC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandMore />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </th>
                                                )}

                                            {(localStorage.getItem('admin') !=
                                                null ||
                                                localStorage.getItem('admin') !=
                                                    '') &&
                                                (localStorage.getItem(
                                                    'employee'
                                                ) == null ||
                                                    localStorage.getItem(
                                                        'employee'
                                                    ) == '') && (
                                                    <th className='right-box'>
                                                        {/* <div className='table-head'>
                                                            <div className='table-title'>Delete</div>
                                                        </div> */}
                                                        <div className='table-head'>
                                                            <div className='table-title'>
                                                                Delete
                                                            </div>
                                                            <div className='sort-container'>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by ascending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'isDeleted',
                                                                            'ASC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandLess />
                                                                </button>
                                                                <button
                                                                    className='sort-button'
                                                                    title='Sort by descending order'
                                                                    onClick={() =>
                                                                        sort(
                                                                            'owners',
                                                                            'isDeleted',
                                                                            'DESC'
                                                                        )
                                                                    }
                                                                >
                                                                    <ExpandMore />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </th>
                                                )}
                                        </tr>
                                    </thead>
                                    {owners[ownerActivePage - 1]?.map(
                                        (owner, index) => {
                                            let className =
                                                owner.isDeleted != 0
                                                    ? 'deleted-row'
                                                    : '';
                                            let dotClassName =
                                                owner.isDeleted != 0
                                                    ? 'dot error'
                                                    : 'dot';

                                            if (
                                                owner.isDeleted == 0 &&
                                                owner.isDisabled == 0 &&
                                                owner.approve == 1 &&
                                                owner.payed != 0
                                            ) {
                                                className = 'success-row';
                                                dotClassName = 'dot success';
                                            }

                                            if (
                                                owner.isDisabled == 1 &&
                                                owner.isDeleted == 0
                                            ) {
                                                className =
                                                    'owner-disabled-row';
                                            }

                                            // let className;
                                            // if (owner.isDeleted != 0) className = 'deleted-row';
                                            // if (owner.isDisabled == 1 && owner.isDeleted == 0) className = 'disable-row';

                                            return (
                                                <tbody
                                                    // key={`owner-${owner.id}`}
                                                    key={Math.random()}
                                                    title={`${owner.shopName} (${owner.station})`}
                                                >
                                                    <tr className='gap'></tr>
                                                    <tr className={className}>
                                                        <td
                                                            className='center left-box'
                                                            onClick={() => {
                                                                if (
                                                                    owner.isDisabled ==
                                                                    '0'
                                                                ) {
                                                                    viewVendors(
                                                                        owner.id,
                                                                        owner.shopName
                                                                    );
                                                                }
                                                            }}
                                                            title='Click to view vendors'
                                                            // onClick={() => { openDialog(index) }}
                                                        >
                                                            <div
                                                                className={
                                                                    dotClassName
                                                                }
                                                            ></div>
                                                            {(ownerActivePage -
                                                                1) *
                                                                ownerItemsPerPage +
                                                                (index + 1)}
                                                        </td>
                                                        <td
                                                            onClick={() => {
                                                                openDialog(
                                                                    index
                                                                );
                                                            }}
                                                        >
                                                            <div className='table-profile-photo'>
                                                                <img
                                                                    src={
                                                                        owner?.photo
                                                                    }
                                                                />
                                                            </div>
                                                        </td>
                                                        {/* <td className='hover'></td>
                                                            <td className='hover'></td>
                                                            <td className='hover'></td>
                                                            <td className='hover'></td>
                                                            <td className='hover'></td> */}
                                                        <td
                                                            className='hightlight'
                                                            onClick={() => {
                                                                openDialog(
                                                                    index
                                                                );
                                                            }}
                                                        >{`${owner.shopName} ${
                                                            owner.isDeleted != 0
                                                                ? '(Deleted)'
                                                                : ''
                                                        } ${
                                                            owner.addedByAdmin !=
                                                            0
                                                                ? '(Added by Admin)'
                                                                : ''
                                                        }`}</td>
                                                        <td
                                                            className='center hightlight'
                                                            onClick={() => {
                                                                openDialog(
                                                                    index
                                                                );
                                                            }}
                                                        >
                                                            {owner.station
                                                                ? owner.station
                                                                : '--'}
                                                        </td>
                                                        <td>
                                                            {
                                                                owner?.stallType ?
                                                                owner?.stallType:'--'
                                                            }
                                                        </td>
                                                        <td>
                                                            {
                                                                owner?.department ?
                                                                owner?.department:'--'
                                                            }
                                                        </td>
                                                        <td
                                                            className={
                                                                owner.isDisabled ==
                                                                    '0' &&
                                                                (localStorage.getItem(
                                                                    'admin'
                                                                ) != null ||
                                                                    localStorage.getItem(
                                                                        'admin'
                                                                    ) != '') &&
                                                                (localStorage.getItem(
                                                                    'employee'
                                                                ) == null ||
                                                                    localStorage.getItem(
                                                                        'employee'
                                                                    ) == '')
                                                                    ? 'hover center'
                                                                    : 'center'
                                                            }
                                                            onClick={() => {
                                                                if (
                                                                    owner.isDisabled ==
                                                                    '0'
                                                                ) {
                                                                    if (
                                                                        (localStorage.getItem(
                                                                            'admin'
                                                                        ) !=
                                                                            null ||
                                                                            localStorage.getItem(
                                                                                'admin'
                                                                            ) !=
                                                                                '') &&
                                                                        (localStorage.getItem(
                                                                            'employee'
                                                                        ) ==
                                                                            null ||
                                                                            localStorage.getItem(
                                                                                'employee'
                                                                            ) ==
                                                                                '')
                                                                    ) {
                                                                        changeNumberOfStall(
                                                                            owner.id,
                                                                            owner.numberOfStall
                                                                        );
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            {
                                                                owner.numberOfStall
                                                            }
                                                        </td>

                                                        <td
                                                            className={
                                                                owner.isDisabled ==
                                                                    '0' &&
                                                                (localStorage.getItem(
                                                                    'admin'
                                                                ) != null ||
                                                                    localStorage.getItem(
                                                                        'admin'
                                                                    ) != '') &&
                                                                (localStorage.getItem(
                                                                    'employee'
                                                                ) == null ||
                                                                    localStorage.getItem(
                                                                        'employee'
                                                                    ) == '')
                                                                    ? 'hover center'
                                                                    : 'center'
                                                            }
                                                            onClick={() => {
                                                                if (
                                                                    owner.isDisabled ==
                                                                    '0'
                                                                ) {
                                                                    if (
                                                                        (localStorage.getItem(
                                                                            'admin'
                                                                        ) !=
                                                                            null ||
                                                                            localStorage.getItem(
                                                                                'admin'
                                                                            ) !=
                                                                                '') &&
                                                                        (localStorage.getItem(
                                                                            'employee'
                                                                        ) ==
                                                                            null ||
                                                                            localStorage.getItem(
                                                                                'employee'
                                                                            ) ==
                                                                                '')
                                                                    ) {
                                                                        changeNumberOfTrolley(
                                                                            owner.id,
                                                                            owner.numberOfTrolley
                                                                        );
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            {
                                                                owner.numberOfTrolley
                                                            }
                                                        </td>

                                                        {/* <td>{owner.shopAddress}</td>
                                                            <td>{owner.shopName}</td> */}
                                                        {/* <td onClick={() => changeVendorsCount(owner.id, owner.vendorsCount)}>
                                                                <div className="input-container">
                                                                    <input type="number" className='inputfield' style={{ width: '150px' }} defaultValue={owner.vendorsCount} disabled />
                                                                </div>
                                                            </td> */}

                                                        {/* Stall/trolley vendor count */}
                                                        <td
                                                            className={
                                                                owner.isDisabled ==
                                                                    '0' &&
                                                                (localStorage.getItem(
                                                                    'admin'
                                                                ) != null ||
                                                                    localStorage.getItem(
                                                                        'admin'
                                                                    ) != '') &&
                                                                (localStorage.getItem(
                                                                    'employee'
                                                                ) == null ||
                                                                    localStorage.getItem(
                                                                        'employee'
                                                                    ) == '')
                                                                    ? 'hover diff-1 center'
                                                                    : 'diff-1 center'
                                                            }
                                                            onClick={() => {
                                                                if (
                                                                    owner.isDisabled ==
                                                                    '0'
                                                                ) {
                                                                    if (
                                                                        (localStorage.getItem(
                                                                            'admin'
                                                                        ) !=
                                                                            null ||
                                                                            localStorage.getItem(
                                                                                'admin'
                                                                            ) !=
                                                                                '') &&
                                                                        (localStorage.getItem(
                                                                            'employee'
                                                                        ) ==
                                                                            null ||
                                                                            localStorage.getItem(
                                                                                'employee'
                                                                            ) ==
                                                                                '')
                                                                    ) {
                                                                        changeStallTrolleyVendorCount(
                                                                            owner.id,
                                                                            owner.stallTrolleyVendorCount
                                                                        );
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            {
                                                                owner.stallTrolleyVendorCount
                                                            }
                                                        </td>

                                                        {/* PF vendor count */}
                                                        <td
                                                            className={
                                                                owner.isDisabled ==
                                                                    '0' &&
                                                                (localStorage.getItem(
                                                                    'admin'
                                                                ) != null ||
                                                                    localStorage.getItem(
                                                                        'admin'
                                                                    ) != '') &&
                                                                (localStorage.getItem(
                                                                    'employee'
                                                                ) == null ||
                                                                    localStorage.getItem(
                                                                        'employee'
                                                                    ) == '')
                                                                    ? 'hover diff-1 center'
                                                                    : 'diff-1 center'
                                                            }
                                                            onClick={() => {
                                                                if (
                                                                    owner.isDisabled ==
                                                                    '0'
                                                                ) {
                                                                    if (
                                                                        (localStorage.getItem(
                                                                            'admin'
                                                                        ) !=
                                                                            null ||
                                                                            localStorage.getItem(
                                                                                'admin'
                                                                            ) !=
                                                                                '') &&
                                                                        (localStorage.getItem(
                                                                            'employee'
                                                                        ) ==
                                                                            null ||
                                                                            localStorage.getItem(
                                                                                'employee'
                                                                            ) ==
                                                                                '')
                                                                    ) {
                                                                        changePfVendorCount(
                                                                            owner.id,
                                                                            owner.pfVendorCount
                                                                        );
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            {
                                                                owner.pfVendorCount
                                                            }
                                                        </td>

                                                        {/* supporting staff */}
                                                        <td
                                                            className={
                                                                owner.isDisabled ==
                                                                    '0' &&
                                                                (localStorage.getItem(
                                                                    'admin'
                                                                ) != null ||
                                                                    localStorage.getItem(
                                                                        'admin'
                                                                    ) != '') &&
                                                                (localStorage.getItem(
                                                                    'employee'
                                                                ) == null ||
                                                                    localStorage.getItem(
                                                                        'employee'
                                                                    ) == '')
                                                                    ? 'hover diff-1 center'
                                                                    : 'diff-1 center'
                                                            }
                                                            onClick={() => {
                                                                if (
                                                                    owner.isDisabled ==
                                                                    '0'
                                                                ) {
                                                                    if (
                                                                        (localStorage.getItem(
                                                                            'admin'
                                                                        ) !=
                                                                            null ||
                                                                            localStorage.getItem(
                                                                                'admin'
                                                                            ) !=
                                                                                '') &&
                                                                        (localStorage.getItem(
                                                                            'employee'
                                                                        ) ==
                                                                            null ||
                                                                            localStorage.getItem(
                                                                                'employee'
                                                                            ) ==
                                                                                '')
                                                                    ) {

                                                                        setOwnerId(owner.id);
                                                                        changeSupportingStaff(
                                                                            owner.id,
                                                                            owner.supportingStaff
                                                                        );
                                                                        // openModal();
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            {
                                                                owner.supportingStaff
                                                            }
                                                        </td>
                                                        {isModalOpen && (
            <div className="modal-overlay">
                <div className="modal-content">
                    <h2>Edit Supporting Staff</h2>
                    <form onSubmit={handleSave}>
                        <div>
                            <label>Manager</label>
                            <input
                                type="number"
                                value={supportingStaffValues.manager}
                                onChange={(e) =>
                                    setSupportingStaffValues({
                                        ...supportingStaffValues,
                                        manager: parseInt(e.target.value, 10),
                                    })
                                }
                            />
                        </div>
                        <div>
                            <label>Assistant Manager</label>
                            <input
                                type="number"
                                value={supportingStaffValues.assistantManager}
                                onChange={(e) =>
                                    setSupportingStaffValues({
                                        ...supportingStaffValues,
                                        assistantManager: parseInt(e.target.value, 10),
                                    })
                                }
                            />
                        </div>
                        <div>
                            <label>Supervisor</label>
                            <input
                                type="number"
                                value={supportingStaffValues.supervisor}
                                onChange={(e) =>
                                    setSupportingStaffValues({
                                        ...supportingStaffValues,
                                        supervisor: parseInt(e.target.value, 10),
                                    })
                                }
                            />
                        </div>
                        <div>
                            <label>Assistant Supervisor</label>
                            <input
                                type="number"
                                value={supportingStaffValues.assistantSupervisor}
                                onChange={(e) =>
                                    setSupportingStaffValues({
                                        ...supportingStaffValues,
                                        assistantSupervisor: parseInt(e.target.value, 10),
                                    })
                                }
                            />
                        </div>
                        <div>
                            <label>Cook</label>
                            <input
                                type="number"
                                value={supportingStaffValues.cook}
                                onChange={(e) =>
                                    setSupportingStaffValues({
                                        ...supportingStaffValues,
                                        cook: parseInt(e.target.value, 10),
                                    })
                                }
                            />
                        </div>
                        <div>
                            <label>Assistant Cook</label>
                            <input
                                type="number"
                                value={supportingStaffValues.assistantCook}
                                onChange={(e) =>
                                    setSupportingStaffValues({
                                        ...supportingStaffValues,
                                        assistantCook: parseInt(e.target.value, 10),
                                    })
                                }
                            />
                        </div>
                        <div>
                            <label>Helper</label>
                            <input
                                type="number"
                                value={supportingStaffValues.helper}
                                onChange={(e) =>
                                    setSupportingStaffValues({
                                        ...supportingStaffValues,
                                        helper: parseInt(e.target.value, 10),
                                    })
                                }
                            />
                        </div>
                        <div>
                            <label>Cleaner</label>
                            <input
                                type="number"
                                value={supportingStaffValues.cleaner}
                                onChange={(e) =>
                                    setSupportingStaffValues({
                                        ...supportingStaffValues,
                                        cleaner: parseInt(e.target.value, 10),
                                    })
                                }
                            />
                        </div>
                        <button type="submit" className="modal-button save-button">
                            Save
                        </button>
                        <button
                            type="button"
                            onClick={closeModal}
                            className="modal-button cancel-button"
                        >
                            Cancel
                        </button>
                    </form>
                </div>
            </div>
        )
    }


                                                        <td
                                                            className='center'
                                                            onClick={() => {
                                                                openDialog(
                                                                    index
                                                                );
                                                            }}
                                                        >
                                                            {+owner.pfVendorCount +
                                                                +owner.stallTrolleyVendorCount +
                                                                +owner.supportingStaff}
                                                        </td>

                                                        {/* <td>{owner.username}</td> */}
                                                        {/* <td>{owner.email}</td> */}
                                                        <td
                                                            className={
                                                                owner.isDisabled ==
                                                                    '0' &&
                                                                (localStorage.getItem(
                                                                    'admin'
                                                                ) != null ||
                                                                    localStorage.getItem(
                                                                        'admin'
                                                                    ) != '') &&
                                                                (localStorage.getItem(
                                                                    'employee'
                                                                ) == null ||
                                                                    localStorage.getItem(
                                                                        'employee'
                                                                    ) == '')
                                                                    ? 'hover center hightlight'
                                                                    : 'center hightlight'
                                                            }
                                                            onClick={() => {
                                                                if (
                                                                    owner.isDisabled ==
                                                                    '0'
                                                                ) {
                                                                    if (
                                                                        (localStorage.getItem(
                                                                            'admin'
                                                                        ) !=
                                                                            null ||
                                                                            localStorage.getItem(
                                                                                'admin'
                                                                            ) !=
                                                                                '') &&
                                                                        (localStorage.getItem(
                                                                            'employee'
                                                                        ) ==
                                                                            null ||
                                                                            localStorage.getItem(
                                                                                'employee'
                                                                            ) ==
                                                                                '')
                                                                    ) {
                                                                        changeMobile(
                                                                            {
                                                                                id: owner.id,
                                                                                name: owner.fullname,
                                                                                mobile: owner.mobile,
                                                                            }
                                                                        );
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            +91 {owner.mobile}
                                                        </td>
                                                        {/* <td>{owner.startingDate}</td> */}
                                                        <td
                                                            // className={owner.isDisabled == '0' && owner.endingDate != null
                                                            //     && (localStorage.getItem('admin') != null || localStorage.getItem('admin') != '')
                                                            //     && (localStorage.getItem('employee') == null || localStorage.getItem('employee') == '')
                                                            //     ? 'hover center' : 'center'}
                                                            className={`center hightlight ${
                                                                owner.endingDate !==
                                                                    null &&
                                                                'hover'
                                                            }`}
                                                            onClick={() => {
                                                                if (
                                                                    // owner.isDisabled == '0' &&
                                                                    owner.endingDate !=
                                                                    null
                                                                ) {
                                                                    if (
                                                                        (localStorage.getItem(
                                                                            'admin'
                                                                        ) !=
                                                                            null ||
                                                                            localStorage.getItem(
                                                                                'admin'
                                                                            ) !=
                                                                                '') &&
                                                                        (localStorage.getItem(
                                                                            'employee'
                                                                        ) ==
                                                                            null ||
                                                                            localStorage.getItem(
                                                                                'employee'
                                                                            ) ==
                                                                                '')
                                                                    ) {
                                                                        changeEndingDate(
                                                                            {
                                                                                id: owner.id,
                                                                                name: owner.fullname,
                                                                                endingDate:
                                                                                    owner.endingDate,
                                                                            }
                                                                        );
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            {owner.endingDate !=
                                                            null
                                                                ? `${new Date(
                                                                      owner.endingDate
                                                                  ).getDate()}-${
                                                                      new Date(
                                                                          owner.endingDate
                                                                      ).getMonth() +
                                                                      1
                                                                  }-${new Date(
                                                                      owner.endingDate
                                                                  ).getFullYear()}`
                                                                : 'Not specified'}
                                                        </td>
                                                        {/* <td>{owner.id}</td> */}
                                                        <td
                                                            className='center'
                                                            onClick={() => {
                                                                openDialog(
                                                                    index
                                                                );
                                                            }}
                                                        >
                                                            {owner.approve ==
                                                                1 &&
                                                            owner.payed != 0
                                                                ? 'Approved'
                                                                : 'Not approved'}
                                                        </td>

                                                        
                                                        {localStorage.getItem('employee') !== null &&
                                                    localStorage.getItem('employee') !== '' && (
                                                        <td
                                                            onClick={() => {
                                                                if (owner.isDisabled == '0') {
                                                                    changePaymentStatus(
                                                                        owner.id,
                                                                        owner.payed
                                                                    );
                                                                }
                                                            }}
                                                            className={
                                                                owner.payed !== 0
                                                                    ? 'success-background center'
                                                                    : 'error-background center'
                                                            }
                                                        >
                                                            {owner.payed !== 0 ? (
                                                                <div className='approval-status'>
                                                                    <CheckUncheck isChecked={true} />
                                                                    {/* Approved */}
                                                                </div>
                                                            ) : (
                                                                <div className='approval-status'>
                                                                    <CheckUncheck isChecked={false} />
                                                                    {/* Not approved */}
                                                                </div>
                                                            )}
                                                        </td>
                                                    )}










                                                        {(localStorage.getItem(
                                                            'admin'
                                                        ) != null ||
                                                            localStorage.getItem(
                                                                'admin'
                                                            ) != '') &&
                                                            (localStorage.getItem(
                                                                'employee'
                                                            ) == null ||
                                                                localStorage.getItem(
                                                                    'employee'
                                                                ) == '') && (
                                                                <td
                                                                    className={
                                                                        owner.isDisabled ==
                                                                        '0'
                                                                            ? 'hover'
                                                                            : ''
                                                                    }
                                                                    onClick={() => {
                                                                        if (
                                                                            owner.isDisabled ==
                                                                            '0'
                                                                        ) {
                                                                            changeStatus(
                                                                                owner.id,
                                                                                owner.approve
                                                                            );
                                                                        }
                                                                    }}
                                                                >
                                                                    {owner.isDisabled ==
                                                                    '0' ? (
                                                                        owner.approve ==
                                                                        0 ? (
                                                                            <div className='success label-large'>
                                                                                Click
                                                                                to
                                                                                approve
                                                                            </div>
                                                                        ) : (
                                                                            <div className='warning label-large'>
                                                                                Click
                                                                                to
                                                                                disapprove
                                                                            </div>
                                                                        )
                                                                    ) : (
                                                                        <>
                                                                            Disabled
                                                                        </>
                                                                    )}
                                                                </td>
                                                        )}

                                                        {(localStorage.getItem(
                                                            'admin'
                                                        ) != null ||
                                                            localStorage.getItem(
                                                                'admin'
                                                            ) != '') &&
                                                            (localStorage.getItem(
                                                                'employee'
                                                            ) == null ||
                                                                localStorage.getItem(
                                                                    'employee'
                                                                ) == '') &&
                                                            JSON.parse(
                                                                localStorage.getItem(
                                                                    'admin'
                                                                )
                                                            ).superAdmin ==
                                                                0 && (
                                                                <td
                                                                    className={
                                                                        owner.isDisabled ==
                                                                        '0'
                                                                            ? 'hover'
                                                                            : ''
                                                                    }
                                                                    onClick={() => {
                                                                        if (
                                                                            owner.isDisabled ==
                                                                            '0'
                                                                        ) {
                                                                            changePaymentStatus(
                                                                                owner.id,
                                                                                owner.payed
                                                                            );
                                                                        }
                                                                    }}
                                                                >
                                                                    {owner.isDisabled ==
                                                                    '0' ? (
                                                                        owner.payed ==
                                                                        0 ? (
                                                                            <div className='success label-large'>
                                                                                Click
                                                                                to
                                                                                approve
                                                                            </div>
                                                                        ) : (
                                                                            <div className='warning label-large'>
                                                                                Click
                                                                                to
                                                                                disapprove
                                                                            </div>
                                                                        )
                                                                    ) : (
                                                                        <>
                                                                            Disabled
                                                                        </>
                                                                    )}
                                                                </td>
                                                            )}


                                                    
                                                    {/* {(localStorage.getItem(
                                                            'admin'
                                                        ) != null ||
                                                            localStorage.getItem(
                                                                'admin'
                                                            ) != '') &&
                                                            (localStorage.getItem(
                                                                'employee'
                                                            ) == null ||
                                                                localStorage.getItem(
                                                                    'employee'
                                                                ) == '') &&
                                                            JSON.parse(
                                                                localStorage.getItem(
                                                                    'admin'
                                                                )
                                                            ).superAdmin ==
                                                                0 && (
                                                                <td
                                                                    className={
                                                                        owner.isDisabled ==
                                                                        '0'
                                                                            ? 'hover'
                                                                            : ''
                                                                    }
                                                                    onClick={() => {
                                                                        if (
                                                                            owner.isDisabled ==
                                                                            '0'
                                                                        ) {
                                                                            changeLoginApprovalStatus(
                                                                                owner.id,
                                                                                owner.login
                                                                            );
                                                                        }
                                                                    }}
                                                                >
                                                                    {owner.isDisabled ==
                                                                    '0' ? (
                                                                        owner.login ==
                                                                        0 ? (
                                                                            <div className='success label-large'>
                                                                                Click
                                                                                to
                                                                                approve
                                                                            </div>
                                                                        ) : (
                                                                            <div className='warning label-large'>
                                                                                Click
                                                                                to
                                                                                disapprove
                                                                            </div>
                                                                        )
                                                                    ) : (
                                                                        <>
                                                                            Disabled
                                                                        </>
                                                                    )}
                                                                </td>
                                                            )} */}



                                             
                                                    
                                                {/* {(localStorage.getItem(
                                                            'admin'
                                                        ) != null ||
                                                            localStorage.getItem(
                                                                'admin'
                                                            ) != '') &&
                                                            (localStorage.getItem(
                                                                'employee'
                                                            ) == null ||
                                                                localStorage.getItem(
                                                                    'employee'
                                                                ) == '') &&
                                                            JSON.parse(
                                                                localStorage.getItem(
                                                                    'admin'
                                                                )
                                                            ).superAdmin ==
                                                                0 && (
                                                                <td
                                                                    className={
                                                                        owner.isDisabled ==
                                                                        '0'
                                                                            ? 'hover'
                                                                            : ''
                                                                    }
                                                                    onClick={() => {
                                                                        if (
                                                                            owner.isDisabled ==
                                                                            '0'
                                                                        ) {
                                                                            changeRPFApprovalStatus(
                                                                                owner?.id,
                                                                                owner?.ipf
                                                                            );
                                                                        }
                                                                    }}
                                                                >
                                                                    {owner.isDisabled ==
                                                                    '0' ? (
                                                                        owner?.ipf ==
                                                                        0 ? (
                                                                            <div className='success label-large'>
                                                                                Click
                                                                                to
                                                                                approve
                                                                            </div>
                                                                        ) : (
                                                                            <div className='warning label-large'>
                                                                                Click
                                                                                to
                                                                                disapprove
                                                                            </div>
                                                                        )
                                                                    ) : (
                                                                        <>
                                                                            Disabled
                                                                        </>
                                                                    )}
                                                                </td>
                                                            )} */}










                                                        <td
                                                            className={
                                                                owner.isDisabled ==
                                                                '0'
                                                                    ? 'hover'
                                                                    : ''
                                                            }
                                                            onClick={() => {
                                                                if (
                                                                    owner.isDisabled ==
                                                                    '0'
                                                                ) {
                                                                    viewVendors(
                                                                        owner.id,
                                                                        owner.shopName
                                                                    );
                                                                }
                                                            }}
                                                        >
                                                            {owner.isDisabled ==
                                                            '0' ? (
                                                                <button className='text-button'>
                                                                    Click to
                                                                    view vendors
                                                                </button>
                                                            ) : (
                                                                'Disabled'
                                                            )}
                                                        </td>
                                                        <td
                                                            className='hover'
                                                            onClick={() => {
                                                                openDialog(
                                                                    index
                                                                );
                                                            }}
                                                        >
                                                            <button className='text-button'>
                                                                Click to view
                                                                contractor
                                                            </button>
                                                        </td>

                                                        {(localStorage.getItem(
                                                            'admin'
                                                        ) != null ||
                                                            localStorage.getItem(
                                                                'admin'
                                                            ) != '') &&
                                                            (localStorage.getItem(
                                                                'employee'
                                                            ) == null ||
                                                                localStorage.getItem(
                                                                    'employee'
                                                                ) == '') && (
                                                                <td
                                                                    className='hover'
                                                                    onClick={() => {
                                                                        toggleStatus(
                                                                            owner.id,
                                                                            owner.isDisabled,
                                                                            owner.fullname
                                                                        );
                                                                    }}
                                                                >
                                                                    <div
                                                                        className={
                                                                            owner.isDisabled ==
                                                                            '0'
                                                                                ? 'warning label-large'
                                                                                : 'success label-large'
                                                                        }
                                                                    >
                                                                        {owner.isDisabled ==
                                                                        '0'
                                                                            ? 'Click to disable'
                                                                            : 'Click to enable'}
                                                                    </div>
                                                                </td>
                                                            )}

                                                        {(localStorage.getItem(
                                                            'admin'
                                                        ) != null ||
                                                            localStorage.getItem(
                                                                'admin'
                                                            ) != '') &&
                                                            (localStorage.getItem(
                                                                'employee'
                                                            ) == null ||
                                                                localStorage.getItem(
                                                                    'employee'
                                                                ) == '') && (
                                                                <td
                                                                    className='hover right-box'
                                                                    onClick={() =>
                                                                        deleteOwner(
                                                                            owner.id,
                                                                            owner.fullname
                                                                        )
                                                                    }
                                                                >
                                                                    <div className='warning label-large'>
                                                                        {owner.isDeleted ==
                                                                        0
                                                                            ? 'Delete'
                                                                            : 'Deleted'}
                                                                    </div>
                                                                </td>
                                                            )}
                                                    </tr>
                                                </tbody>
                                            );
                                        }
                                    )}
                                    {/* </tbody > */}
                                </table>
                            </div>
                            {/* <Pagination
                                getTotalItems={ownerTotalItems}
                                getItemsPerPage={ownerItemsPerPage}
                                getPageNumber={getPageNumberOwner}
                                activePage={ownerActivePage}
                            />
                            <Pagination getTotalItems={totalItems} getItemsPerPage={itemsPerPage} /> */}
                        </>
                    ) : (
                        <></>
                    )}

                    {/* <Pagination tabelName='owners' activePage={ownerActivePage} getPageNumber={getPageNumberOwner} /> */}
                    <Pagination
                                getTotalItems={ownerTotalItems}
                                getItemsPerPage={ownerItemsPerPage}
                                getPageNumber={getPageNumberOwner}
                                activePage={ownerActivePage}
                            />
                    <Footer />
                </div>
            </div>

            {dialog && (
                <div className='dialog-container'>
                    <dialog
                        open
                        className='dialog owner-details-dialog'
                    >
                        <div className='dialog-top'>
                            <div className='title title-large'>
                                Contractor details
                            </div>
                            {!isEditingOwner && (
                                <button
                                    className='outlined-button'
                                    onClick={startEditOwner}
                                >
                                    Edit
                                </button>
                            )}
                            <button
                                className='icon-button'
                                onClick={closeDialog}
                            >
                                <Clear />
                            </button>
                        </div>

                        <div className='dialog-content'>
                        {isEditingOwner ? (
                            <div className='owner-edit-form'>
                                <div className='owner-edit-photos'>
                                    {[
                                        { key: 'photo', label: 'Passport photo' },
                                        { key: 'idPhoto', label: 'Id proof' },
                                        { key: 'shopPhoto', label: 'Stall photo' },
                                        { key: 'signPhoto', label: 'Signature' },
                                        { key: 'stampPhoto', label: 'Stamp' },
                                    ].map(({ key, label }) => (
                                        <div className='owner-edit-photo-item' key={key}>
                                            <div className='container-label label-small'>
                                                {label}
                                            </div>
                                            <img
                                                className='img'
                                                src={
                                                    ownerEditFiles[key]
                                                        ? URL.createObjectURL(
                                                              ownerEditFiles[key]
                                                          )
                                                        : dialog[key]
                                                }
                                                alt=''
                                            />
                                            <label className='outlined-button file-input-label'>
                                                Replace
                                                <input
                                                    type='file'
                                                    accept='image/*'
                                                    name={key}
                                                    hidden
                                                    onChange={
                                                        handleOwnerEditFileChange
                                                    }
                                                />
                                            </label>
                                        </div>
                                    ))}
                                </div>

                                <div className='label label-medium'>
                                    Contractor fullname
                                </div>
                                <input
                                    className='inputfield'
                                    name='fullname'
                                    value={ownerEditForm.fullname}
                                    onChange={handleOwnerEditFormChange}
                                />

                                <div className='label label-medium'>
                                    Stall name
                                </div>
                                <input
                                    className='inputfield'
                                    name='shopName'
                                    value={ownerEditForm.shopName}
                                    onChange={handleOwnerEditFormChange}
                                />

                                <div className='label label-medium'>
                                    Station
                                </div>
                                <select
                                    className='inputfield'
                                    name='station'
                                    value={ownerEditForm.station}
                                    onChange={handleOwnerEditFormChange}
                                >
                                    <option value={ownerEditForm.station}>
                                        {ownerEditForm.station}
                                    </option>
                                    {stations
                                        .filter(
                                            (item) =>
                                                item.station !==
                                                ownerEditForm.station
                                        )
                                        .map((item, index) => (
                                            <option
                                                key={index}
                                                value={item.station}
                                            >
                                                {item.station}
                                            </option>
                                        ))}
                                </select>

                                <div className='label label-medium'>
                                    Stall Type
                                </div>
                                <input
                                    className='inputfield'
                                    name='stallType'
                                    value={ownerEditForm.stallType}
                                    onChange={handleOwnerEditFormChange}
                                />

                                <div className='label label-medium'>
                                    Category
                                </div>
                                <input
                                    className='inputfield'
                                    name='category'
                                    value={ownerEditForm.category}
                                    onChange={handleOwnerEditFormChange}
                                />

                                <div className='label label-medium'>
                                    Department
                                </div>
                                <select
                                    className='inputfield'
                                    name='department'
                                    value={ownerEditForm.department}
                                    onChange={handleOwnerEditFormChange}
                                >
                                    <option value='Catering'>Catering</option>
                                    <option value='Other'>Other</option>
                                </select>

                                <div className='label label-medium'>
                                    Email id
                                </div>
                                <input
                                    className='inputfield'
                                    name='email'
                                    value={ownerEditForm.email}
                                    onChange={handleOwnerEditFormChange}
                                />

                                <div className='label label-medium'>
                                    Mobile no.
                                </div>
                                <input
                                    className='inputfield'
                                    name='mobile'
                                    value={ownerEditForm.mobile}
                                    onChange={handleOwnerEditFormChange}
                                />

                                <div className='label label-medium'>
                                    Stall start date
                                </div>
                                <input
                                    type='date'
                                    className='inputfield'
                                    name='startingDate'
                                    value={ownerEditForm.startingDate}
                                    onChange={handleOwnerEditFormChange}
                                />

                                <div className='label label-medium'>
                                    Stall validity date
                                </div>
                                <input
                                    type='date'
                                    className='inputfield'
                                    name='endingDate'
                                    value={ownerEditForm.endingDate}
                                    onChange={handleOwnerEditFormChange}
                                />

                                <div className='dialog-buttons-container'>
                                    <button
                                        className='outlined-button'
                                        disabled={savingOwner}
                                        onClick={cancelEditOwner}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className='filled-button'
                                        disabled={savingOwner}
                                        onClick={saveOwnerEdits}
                                    >
                                        {savingOwner
                                            ? 'Savingâ€¦'
                                            : 'Save changes'}
                                    </button>
                                </div>
                            </div>
                        ) : (
                        <>
                            <div className='container-1'>
                                <div className='profile-image'>
                                    <div className='container-label label-small'>
                                        Passport photo
                                    </div>
                                    <img
                                        className='img'
                                        src={dialog.photo}
                                        alt=''
                                    />
                                </div>
                                <div className='id-image'>
                                    <div className='container-label label-small'>
                                        Id proof
                                    </div>
                                    <img
                                        className='img'
                                        src={dialog.idPhoto}
                                        alt=''
                                    />
                                </div>
                            </div>
                            <div className='container-2'>
                                <div className='shop-image'>
                                    <div className='container-label label-small'>
                                        Stall photo
                                    </div>
                                    <img
                                        className='img'
                                        src={dialog.shopPhoto}
                                        alt=''
                                    />
                                </div>
                                <div className='sign-image'>
                                    <div className='container-label label-small'>
                                        Signature
                                    </div>
                                    <img
                                        className='img'
                                        src={dialog.signPhoto}
                                        alt=''
                                    />
                                </div>
                                <div className='stamp-image'>
                                    <div className='container-label label-small'>
                                        Stamp
                                    </div>
                                    <img
                                        className='img'
                                        src={dialog.stampPhoto}
                                        alt=''
                                    />
                                </div>
                            </div>

                            {dialog.reason == null && (
                                <div
                                    className={
                                        calculateDateStatus(dialog.endingDate)
                                            .className
                                    }
                                >
                                    {
                                        calculateDateStatus(dialog.endingDate)
                                            .message
                                    }
                                </div>
                            )}

                            {/* {
                                JSON.parse(localStorage.getItem('admin')).superAdmin == 0 &&
                                <>
                                    <div className='label label-medium'>Payment screenshot</div>
                                    <a rel="noopener noreferrer" href={dialog.payScreenshot} target="_blank">{dialog.payScreenshot ? 'Click to view screenshot' : 'Screenshot not found'}</a>
                                </>
                            } */}

                            <div className='container-3'>
                                <div className='label label-medium'>
                                    Contractor fullname
                                </div>
                                <div className='full-name title-large'>
                                    {dialog.fullname}
                                </div>

                                <div className='label label-medium'>
                                    Stall location{' '}
                                    {(localStorage.getItem('admin') != null ||
                                        localStorage.getItem('admin') != '') &&
                                        (localStorage.getItem('employee') ==
                                            null ||
                                            localStorage.getItem('employee') ==
                                                '') && (
                                            <button
                                                className='icon-button'
                                                style={{
                                                    display: 'inline-grid',
                                                }}
                                                onClick={() =>
                                                    updateStallLocation(
                                                        dialog.id,
                                                        dialog.shopAddress
                                                    )
                                                }
                                            >
                                                <Edit />
                                            </button>
                                        )}
                                </div>
                                <div className='id-number body-large'>
                                    {dialog.shopAddress}
                                </div>

                                <div className='label label-medium'>
                                    Station
                                </div>
                                <div className='id-number body-large'>
                                    {dialog.station}
                                </div>

                                <div className='label label-medium'>
                                    Stall Type
                                </div>
                                <div className='id-number body-large'>
                                    {dialog.stallType}
                                </div>

                                <div className='label label-medium'>
                                    Category
                                </div>
                                <div className='id-number body-large'>
                                    {dialog.category}
                                </div>

                                <div className='label label-medium'>
                                    Department
                                </div>
                                <div className='id-number body-large'>
                                    {dialog.department || 'Not set'}
                                </div>

                                <div className='details-container-1'>
                                    <div>
                                        <div className='label label-medium'>
                                            Stall name
                                        </div>
                                        <div className='aadhaar-id body-large'>
                                            {dialog.shopName}
                                        </div>
                                    </div>

                                    <div>
                                        <div className='label label-medium'>
                                            Stall start date
                                        </div>
                                        <div className='valid-upto-date body-large'>
                                            {dialog.startingDate != null
                                                ? `${new Date(
                                                      dialog.startingDate
                                                  ).getDate()}-${
                                                      new Date(
                                                          dialog.startingDate
                                                      ).getMonth() + 1
                                                  }-${new Date(
                                                      dialog.startingDate
                                                  ).getFullYear()}`
                                                : 'Not specified'}
                                        </div>
                                    </div>

                                    <div>
                                        <div className='label label-medium'>
                                            Stall validity date
                                        </div>
                                        <div className='valid-for body-large'>
                                            {dialog.endingDate != null
                                                ? `${new Date(
                                                      dialog.endingDate
                                                  ).getDate()}-${
                                                      new Date(
                                                          dialog.endingDate
                                                      ).getMonth() + 1
                                                  }-${new Date(
                                                      dialog.endingDate
                                                  ).getFullYear()}`
                                                : 'Not specified'}
                                        </div>
                                    </div>
                                </div>

                                {dialog.reason != null ? (
                                    <div>
                                        <div className='label label-medium'>
                                            Reason for not having validity
                                        </div>
                                        <div className='unit body-large'>
                                            {dialog.reason}
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )}

                                <div className='details-container-1'>
                                    <div>
                                        <div className='label label-medium'>
                                            Email id
                                        </div>
                                        <div className='unit body-large'>
                                            {dialog.email}
                                        </div>
                                    </div>

                                    <div>
                                        <div className='label label-medium'>
                                            Mobile no.
                                        </div>
                                        <div className='issue-date body-large'>
                                            {dialog.mobile}
                                        </div>
                                    </div>

                                    {/* <div>
                                        <div className='label label-medium'>Username</div>
                                        <div className='designation body-large'>{dialog.username}</div>
                                    </div> */}

                                    {/* <div>
                                        <div className='label label-medium'>Mobile no.</div>
                                        <div className='issue-date body-large'>{dialog.mobile}</div>
                                    </div> */}
                                </div>

                                <div className='details-container-1'>
                                    <div>
                                        <div className='label label-medium'>
                                            Number of stalls
                                        </div>
                                        <div className='unit body-large'>
                                            {dialog.numberOfStall}
                                        </div>
                                    </div>
                                    <div>
                                        <div className='label label-medium'>
                                            Number of trolleys
                                        </div>
                                        <div className='unit body-large'>
                                            {dialog.numberOfTrolley}
                                        </div>
                                    </div>
                                    <div></div>
                                </div>

                                <div className='details-container-1'>
                                    <div>
                                        <div className='label label-medium'>
                                            Number of staff
                                        </div>
                                        <div className='unit body-large'>
                                            {dialog.stallTrolleyVendorCount}
                                        </div>
                                    </div>
                                    <div>
                                        <div className='label label-medium'>
                                            PF vendor
                                        </div>
                                        <div className='unit body-large'>
                                            {dialog.pfVendorCount}
                                        </div>
                                    </div>
                                    <div>
                                        <div className='label label-medium'>
                                            Supporting staff
                                        </div>
                                        <div className='unit body-large'>
                                            {dialog.supportingStaff}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        )}
                        </div>
                    </dialog>
                </div>
            )}

            {loader && <Loading />}
        </>
    );
};

export default Owners;

//------------------------------------------------------------------------------------